import jq from 'jquery';
import { cookieBase, siteName } from 'server-data/flconfigs';
import { oneLine } from 'common-tags';
import 'css/flux/modules/Modal.less';
import GoogleMapsLoader from 'google-maps';
import Fuse from 'fuse.js';
import 'css/abtests/CTS-627/modules/AutofillDropdown.less';
import { initialPageNumber, showAlertModal, pageName, gotoUrl, exchangerate, initialTotalEntries, resultSetSize, defaultResultSetSize, showPostBtn, showBidBtn } from 'server-data/job-search-new';

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function setArrayCookie(cName, value, expiredays) {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  setCookie(cName, value, expiredays);
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function getArrayCookie(cName) {
  var fromCookie = getCookie(cName);
  if (fromCookie) {
    return JSON.parse(fromCookie);
  }

  return [];
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

var template$1 = "<div id=\"<%=  id  %>\" class=\"Modal <%=  extraClass  %>\" data-modal aria-hidden=\"<%=  hideModal  %>\">\n  <div class=\"Modal-inner\" <%  if (backdropClose) {  %> data-modal-outbound <%  }  %>>\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <%  if (closeButton) {  %>\n        <button class=\"Modal-close\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\">\n          <span class=\"Icon Icon--small\"><%=  uiIcon('ui-close')  %></span>\n        </button>\n        <%  }  %>\n        <%  if (header) {  %>\n        <header class=\"Modal-header\">\n          <%=  header  %>\n        </header>\n        <%  }  %>\n        <%  if (body) {  %>\n        <div class=\"Modal-body\">\n          <%=  body  %>\n        </div>\n        <%  }  %>\n        <%  if (footer) {  %>\n        <footer class=\"Modal-footer\">\n          <%=  footer  %>\n        </footer>\n        <%  }  %>\n      </div>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var OPEN_EVENT = {
  METHOD: 'method'
};

var CLOSE_EVENT = {
  ESC: 'esc',
  OUTOFBOUNDS: 'outofbounds',
  ELEMENT: 'element'
};

var SIZE = {
  SMALL: 'Modal--small',
  LARGE: 'Modal--large',
  FULLSCREEN: 'Modal--fullscreen'
};

var defaultOptions = {
  main: document.querySelector('#main'),
  closeButton: true,
  backdropClose: true,
  extraClass: '',
  size: '',
  type: ''
};

// Template the modal's scaffolding by injecting header, body and footer
var scaffold = template(template$1);

/**
 * Modal constructor
 * @param {Node} node Dialog element
 * @param {Node} main Main element of the page
 */

var Modal = function () {
  /**
   * Modal constructor
   * @param  {String}   id                       An ID to apply to the modal.
   * @param  {Object}   content                  Content object to inject in the
   *                                             modal.
   * @param  {String}   content.header           Content for the header.
   * @param  {String}   content.body             Content for the body.
   * @param  {String}   content.footer           Content for the footer.
   * @param  {Object}   [options={}]             Options object for customise
   *                                             behaviour of modal.
   * @param  {Node}     [options.main]           An element to treat as the main
   *                                             content so that
   *                                             aria-hidden="true" can be
   *                                             toggled. Defaults to #main.
   * @param  {Boolean}  [options.closeButton]    Shows the x close button.
   *                                             Defaults to true.
   * @param  {Boolean}  [options.backdropClose]  Enables closing of modal via
   *                                             clicking on the backdrop.
   *                                             Defaults to true.
   * @param  {String}   [options.extraClass]     Adds extra classes to the
   *                                             modal.
   * @param  {String}   [options.size]           Sets the size of the modal.
   * @param  {String}   [options.type]           Sets the type of the modal.
   * @param  {Function} [options.onShow]         Callback function after showing
   *                                             the modal.
   * @param  {Function} [options.onHide]        Callback function after closing
   *                                             the modal.
   * @return {Modal}                             Modal instance.
   */
  function Modal(id, content, opts) {
    _classCallCheck(this, Modal);

    // Merge user options with defaultOptions
    var options = Object.assign({}, defaultOptions, opts);

    // Build configuration
    this.config = {
      id: id,
      content: {
        header: content.header,
        body: content.body,
        footer: content.footer
      },
      options: options
    };

    // Errors
    if (typeof this.config.id === 'undefined') {
      throw new TypeError('Modal id cannot be undefined.');
    }

    if (typeof this.config.content === 'undefined') {
      throw new TypeError('Modal content cannot be undefined.');
    }

    if (typeof this.config.options.main === 'undefined') {
      throw new TypeError('#main element does not exist.');
    }

    this.namespace = 'data-modal';
    this.body = document.body;
    this.main = this.config.options.main;

    // Appends markup to the body just before the </body>
    this.body.insertAdjacentHTML('beforeend', scaffold({
      uiIcon: uiIcon,
      id: this.config.id,
      hideModal: true,
      header: this.config.content.header,
      body: this.config.content.body,
      footer: this.config.content.footer,
      closeButton: this.config.options.closeButton,
      backdropClose: this.config.options.backdropClose,
      extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
    }));

    this.node = document.getElementById(this.config.id);
    this.shown = false;

    this._bindEventsToModal();
    return this;
  }

  /**
   * Helper function that binds modal events to the modal element
   */

  _createClass(Modal, [{
    key: '_bindEventsToModal',
    value: function _bindEventsToModal() {
      var _this = this;

      // Bind show modal event to elements with <this.namespace>-show="<modal-id>"
      // data attributes
      Array.from(
      // Get all the elements with <this.namespace>-show="<modal-id>"
      document.querySelectorAll('[' + this.namespace + '-show="' + this.node.id + '"]')).forEach(function (opener) {
        opener.addEventListener('click', function () {
          return _this.show();
        });
      });

      // Bind hide modal event to elements with <this.namespace>-hide data
      // attributesmodules/membership/index.js
      Array.from(
      // Get all elements with <this.namespace>-hide inside the modal
      this.node.querySelectorAll('[' + this.namespace + '-hide]'))
      // Then combine it with all elements on the page that targets the modal
      // with <this.namespace>-hide="<modal-id>" for hiding
      .concat(Array.from(document.querySelectorAll('[' + this.namespace + '-hide="' + this.node.id + '"]'))).forEach(function (closer) {
        closer.addEventListener('click', function () {
          return _this.hide(CLOSE_EVENT.ELEMENT);
        });
      });

      // Hides modal when the user clicks out of bounds
      this.node.addEventListener('click', function (event) {
        if (event.target.hasAttribute(_this.namespace + '-outbound')) {
          _this.hide(CLOSE_EVENT.OUTOFBOUNDS);
        }
      });

      document.addEventListener('keydown', function (event) {
        // keydown on Esc key
        if (_this.shown && event.which === 27) {
          event.preventDefault();
          _this.hide(CLOSE_EVENT.ESC);
        }

        // keydown on Tab key
        if (_this.shown && event.which === 9) {
          _this._trapTabKey(_this.node, event);
        }
      });

      this.body.addEventListener('focus', function (event) {
        if (_this.shown && !_this.node.contains(event.target)) {
          _this._setFocusToFirstItem(_this.node);
        }
      }, true);
    }

    /**
     * Helper function to get all focusable children from a node
     * @param  {Node} node Node to look in
     * @return {Array}     Array of focusable nodes
     */

  }, {
    key: '_getFocusableChildren',
    value: function _getFocusableChildren(node) {
      var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

      return Array.from(node.querySelectorAll(focusableElements.join(','))).filter(function (child) {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
      });
    }

    /**
     * Helper function trapping the tab key inside a node
     * @param  {Node} node    Node to trap tab key in
     * @param  {Object} event Event to intercept
     */

  }, {
    key: '_trapTabKey',
    value: function _trapTabKey(node, event) {
      var focusableChildren = this._getFocusableChildren(node);
      var focusedItemIndex = focusableChildren.indexOf(document.activeElement);

      if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
      } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
      }
    }

    /**
     * Helper function to focus first focusable item in node
     * @param {Node} node Node to search in for first focusable
     */

  }, {
    key: '_setFocusToFirstItem',
    value: function _setFocusToFirstItem(node) {
      var focusableChildren = this._getFocusableChildren(node);
      if (focusableChildren.length) focusableChildren[0].focus();
    }

    /**
     * Checks if scrollbar is visible.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_checkScrollbar',
    value: function _checkScrollbar() {
      var fullWindowWidth = window.innerWidth;

      this.bodyIsOverflowing = this.body.clientWidth < fullWindowWidth;
      this.scrollbarWidth = this._measureScrollbar();
    }

    /**
     * Sets the scrollbar padding offset on the body element.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_setScrollbar',
    value: function _setScrollbar() {
      var bodyPadding = parseInt(this.body.style.paddingRight || 0, 10);

      this.originalBodyPadding = this.body.style.paddingRight || '';

      if (this.bodyIsOverflowing) {
        this.body.style.paddingRight = '' + bodyPadding + this.scrollbarWidth + 'px';
      }
    }

    /**
     * Resets the padding on the body to the way it was with the scrollbar.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_resetScrollbar',
    value: function _resetScrollbar() {
      this.body.style.paddingRight = this.originalBodyPadding;
    }

    /**
     * Measures the width of the scrollbar.
     * Ported from the bootstrap v3.3.6.
     *
     * @return {Number} Width of the scrollbar.
     */

  }, {
    key: '_measureScrollbar',
    value: function _measureScrollbar() {
      var scrollDiv = document.createElement('div');
      // Injects some styling to the element which forces the display of a scroll
      // bar and places it off the page to ensure it is never visible.
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';

      this.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      this.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }

    /**
     * Show the modal with optional eventType identifier
     * @param  {String} eventType An identifier string to pass into the onShow
     *                            callback method.
     */

  }, {
    key: 'show',
    value: function show(eventType) {
      this.shown = true;
      this._checkScrollbar();
      this._setScrollbar();
      this.body.setAttribute(this.namespace + '-open', '');
      this.node.removeAttribute('aria-hidden');
      this.main.setAttribute('aria-hidden', 'true');
      this.focusedBeforeDialog = document.activeElement;
      this._setFocusToFirstItem(this.node);
      eventType = eventType || OPEN_EVENT.METHOD;

      if (this.config.options.onShow) {
        this.config.options.onShow(eventType);
      }
    }

    /**
     * Hide the modal
     * @param  {String} eventType An identifier string to pass into the onHide
     *                            callback method.
     */

  }, {
    key: 'hide',
    value: function hide(eventType) {
      this.shown = false;
      this._resetScrollbar();
      this.body.removeAttribute(this.namespace + '-open', '');
      this.node.setAttribute('aria-hidden', 'true');
      this.main.removeAttribute('aria-hidden');
      this.focusedBeforeDialog.focus();

      if (this.config.options.onHide) {
        this.config.options.onHide(eventType);
      }
    }

    /**
     * Dynamically change the template of the modal given the new template.
     * Use this if you want to change the content without creating a new modal
     * as this does not automatically hide the new content upon replacement
     *
     * @param  {Object} content Content object to inject in the modal.
     */

  }, {
    key: 'replaceTemplate',
    value: function replaceTemplate(content) {
      var newModalContent = scaffold({
        uiIcon: uiIcon,
        id: this.config.id,
        hideModal: false,
        header: content.header,
        body: content.body,
        footer: content.footer,
        closeButton: this.config.options.closeButton,
        backdropClose: this.config.options.backdropClose,
        extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
      });

      // convert content to nodes
      var newModal = document.createElement('div');
      newModal.innerHTML = newModalContent;
      var newTemplate = newModal.childNodes[0];

      // replace with new template
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(newTemplate.children, function (child) {
        var childNode = child instanceof Node ? child : document.createTextNode(String(child));
        fragment.appendChild(childNode);
      });

      this.node.replaceChild(fragment, this.node.children[0]);

      // bind modal events
      this.node = document.getElementById(this.config.id);
      this._bindEventsToModal();
    }
  }]);

  return Modal;
}();

GoogleMapsLoader.KEY = 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.LANGUAGE = 'en';

var gmapPromise = new Promise(function (resolve) {
  GoogleMapsLoader.load(resolve);
});

var AUTOCOMPLETE_PREFERENCE = {
  country: 0,
  administrative_area_level_1: 1,
  locality: 2,
  vicinity: 3,
  formatted_address: 4
};

/**
 * Sets an input field and a link or button to get the geographic
 * information of a location.
 * @param {String} opts The object containing the configuration for geocoding.
 * @param {String} opts.autoCompleteElement The id of the input field that will
 *                                          have an autocomplete dropdown of
 *                                          possible locations when a user
 *                                          types in it.
 * @param {String} opts.autoCompletePreference The value to be filled into the
 *                                             autoCompleteElement.
 *                                             Defaulted to formatted_address
 * @param {Function} opts.autoCompleteCallback Callback function after showing
 *                                             the autocomplete dropdown.
 * @param {Function} opts.reverseGeocodingElement The id of the link or button
 *                                                that would get the current
 *                                                browser location.
 * @param {Function} opts.reverseGeocodingSuccessCallback Callback function
 *                                                        after getting the
 *                                                        browser location.
 * @param {Function} opts.reverseGeocodingErrorCallback Callback function when
 *                                                      the browser location
 *                                                      cannot be determined.
 * @param {Array} opts.placeTypes Place types which the autocomplete is limited to.
 *                                See https://developers.google.com/places/web-service/supported_types#table3.
 */

var Geocoding = function () {
  function Geocoding(opts) {
    var _this = this;

    _classCallCheck(this, Geocoding);

    this.config = opts;
    gmapPromise.then(function (google) {
      _this.gmap = google.maps;
      _this.autoComplete = new _this.gmap.places.Autocomplete(
      /* @type {HTMLInputElement} */
      document.getElementById(_this.config.autoCompleteElement), {
        // WARNING: don't put anything in fields that isn't "Basic Data"
        // https://developers.google.com/maps/billing/gmp-billing#data-skus
        // or it could incur significant extra costs to our google maps usage
        fields: ['address_components', 'formatted_address', 'geometry.location', 'vicinity']
      });

      if (_this.config.restrictLocation) {
        _this.autoComplete.setComponentRestrictions({
          country: _this.config.restrictLocation
        });
      }

      if (_this.config.placeTypes) {
        _this.autoComplete.setTypes(_this.config.placeTypes);
      }

      _this.gmap.event.addListener(_this.autoComplete, 'place_changed', function () {
        if (_this.config.autoCompleteCallback) {
          _this.config.autoCompleteCallback(_this.getSelectedAddressGeoInfo());
        }
      });

      if (_this.config.initialLocation) {
        _this.setInitialLocation(_this.config.initialLocation);
      }
    });

    if (this.config.reverseGeocodingElement) {
      var reverseGeocodingElement = document.getElementById(this.config.reverseGeocodingElement);
      reverseGeocodingElement.addEventListener('click', function () {
        return _this.reverseGeocodeCurrentLocation();
      });
    }
  }

  _createClass(Geocoding, [{
    key: 'reverseGeocodeCurrentLocation',
    value: function reverseGeocodeCurrentLocation() {
      var _this2 = this;

      if (navigator.geolocation) {
        var geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(function (position) {
          _this2.getReverseGeoInfo(position.coords.latitude, position.coords.longitude);
        }, function (err) {
          if (_this2.config.reverseGeocodingErrorCallback) {
            _this2.config.reverseGeocodingErrorCallback('Failed to determine current location: ' + err.toString());
          }
        }, geoOptions);
      }
    }
  }, {
    key: 'setInitialLocation',
    value: function setInitialLocation(location) {
      var _this3 = this;

      var geoInfo = void 0;

      if (!location.formatted_address) {
        if (location.latitude && location.longitude) {
          this.getReverseGeoInfo(location.latitude, location.longitude);
        }
        return;
      }

      var geocoder = new this.gmap.Geocoder();
      var params = { address: location.formatted_address };
      geocoder.geocode(params, function (results, status) {
        if (status === _this3.gmap.GeocoderStatus.OK) {
          geoInfo = _this3.formatGeoInfo(results[0]);
          var autoCompleteElement = document.getElementById(_this3.config.autoCompleteElement);
          autoCompleteElement.value = geoInfo.formatted_address;
          if (_this3.config.reverseGeocodingSuccessCallback) {
            _this3.config.reverseGeocodingSuccessCallback(geoInfo);
          }
        } else if (location.latitude && location.longitude) {
          _this3.getReverseGeoInfo(location.latitude, location.longitude);
        }
      });
    }
  }, {
    key: 'getAddressComponentName',
    value: function getAddressComponentName(addressComponents, type, long_short_identifier) {
      var component = addressComponents.find(function (comp) {
        return comp.types.includes(type);
      });
      return component ? component['' + long_short_identifier] : '';
    }
  }, {
    key: 'formatGeoInfo',
    value: function formatGeoInfo(place) {
      var geoInfo = {
        administrative_area_level_1: '',
        country: '',
        formatted_address: '',
        lat: '',
        lng: '',
        vicinity: '',
        administrative_area_level_1_name: '',
        postal_code: ''
      };

      var geoInfoAddressComponents = place.address_components;

      if (!geoInfoAddressComponents) {
        return false;
      }

      geoInfo.administrative_area_level_1 = this.getAddressComponentName(geoInfoAddressComponents, 'administrative_area_level_1', 'short_name');
      geoInfo.country = this.getAddressComponentName(geoInfoAddressComponents, 'country', 'long_name');
      geoInfo.locality = this.getAddressComponentName(geoInfoAddressComponents, 'locality', 'long_name');
      geoInfo.postal_code = this.getAddressComponentName(geoInfoAddressComponents, 'postal_code', 'long_name');
      geoInfo.administrative_area_level_1_name = this.getAddressComponentName(geoInfoAddressComponents, 'administrative_area_level_1', 'long_name');
      geoInfo.formatted_address = place.formatted_address;
      geoInfo.lat = place.geometry.location.lat();
      geoInfo.lng = place.geometry.location.lng();
      geoInfo.vicinity = place.vicinity || geoInfo.locality || geoInfo.administrative_area_level_1 || geoInfo.country || '';
      return geoInfo;
    }
  }, {
    key: 'getSelectedAddressGeoInfo',
    value: function getSelectedAddressGeoInfo() {
      var place = this.autoComplete.getPlace();
      return this.formatGeoInfo(place);
    }
  }, {
    key: 'getReverseGeoInfo',
    value: function getReverseGeoInfo(latitude, longitude) {
      var _this4 = this;

      var geocoder = new this.gmap.Geocoder();
      var latlng = new this.gmap.LatLng(latitude, longitude);

      geocoder.geocode({ latLng: latlng }, function (results, status) {
        if (status === _this4.gmap.GeocoderStatus.OK) {
          var geoInfo = _this4.formatGeoInfo(results[0]);

          var autoCompleteElement = document.getElementById(_this4.config.autoCompleteElement);
          if (_this4.config.autoCompletePreference === AUTOCOMPLETE_PREFERENCE.country) {
            autoCompleteElement.value = geoInfo.country;
          } else if (_this4.config.autoCompletePreference === AUTOCOMPLETE_PREFERENCE.locality) {
            autoCompleteElement.value = geoInfo.locality;
          } else if (_this4.config.autoCompletePreference === AUTOCOMPLETE_PREFERENCE.vicinity) {
            autoCompleteElement.value = geoInfo.vicinity;
          } else {
            autoCompleteElement.value = geoInfo.formatted_address;
          }
          if (_this4.config.reverseGeocodingSuccessCallback) {
            _this4.config.reverseGeocodingSuccessCallback(geoInfo);
          }
        } else if (_this4.config.reverseGeocodingErrorCallback) {
          _this4.config.reverseGeocodingErrorCallback(status);
        }
      });
    }
  }]);

  return Geocoding;
}();

/**
 * Factory method to create Geocoding class
 */

function createGeocoding(opts) {
  return new Geocoding(opts);
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
function now() {
  return Date.now();
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = isFunction(value.valueOf) ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

function request(url, opts) {
  var defaultOptions = {
    credentials: 'same-origin', // allow cookies to be sent
    headers: new Headers({
      'X-XSRF-TOKEN': getCSRFToken(), // always send the CSRF token header
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      accept: 'application/json, text/javascript, */*; q=0.01'
    })
  };

  var options = Object.assign({}, defaultOptions, opts);

  return fetch(url, options).then(function (response) {
    if (response.ok) {
      return response.json();
    }

    throw new Error(response.statusText);
  });
}

function doPostRequest(data) {
  var url = '/ajax/table/project_contest_datatable.php?';
  url += Object.keys(data).reduce(function (total, key) {
    return total + key + '=' + encodeURIComponent(data[key]) + '&';
  }, '');
  var defaultOptions = {
    method: 'GET'
  };

  var options = Object.assign({}, defaultOptions);
  return request(url, options);
}

var tableTemplate = "<%  for (var i = 0; i < projects.length; i++) {  %>\n    <div class=\"JobSearchCard-item <%  if (projects[i].highlight) {  %> JobSearchCard-item--highlight <%  }  %>\">\n        <div class=\"JobSearchCard-item-inner\" data-project-card=\"true\">\n            <div class=\"JobSearchCard-primary\">\n                <div class=\"JobSearchCard-primary-heading\">\n                    <%  if (projects[i].is_contest) {  %>\n                    <span class=\"Icon JobSearchCard-primary-heading-Icon\">\n                        <%=  uiIcon('flicon-trophy')  %>\n                    </span>\n                    <%  }  %>\n\n                    <%  if (projects[i].is_private) {  %>\n                    <a href=\"<%=  projects[i].login_redirect_url  %>\" class=\"JobSearchCard-primary-heading-link\" data-heading-link=\"true\">\n                        <%= T_('Mradi ama shindano la kibinafsi #<[- project_id ]>', { project_id: projects[i].project_id }) %>\n                    </a>\n                    <%  } else {} %>\n\n                    <%  if (!projects[i].is_private) {  %>\n                    <a href=\"<%=  projects[i].seo_url  %>\" class=\"JobSearchCard-primary-heading-link\" data-qtsb-section=\"page-job-search-new\" data-qtsb-subsection=\"card-job\" data-qtsb-label=\"link-project-title\" data-heading-link=\"true\">\n                        <%=  projects[i].project_name  %>\n                    </a>\n                    <%  }  %>\n\n                    <span class=\"JobSearchCard-primary-heading-days\"><%=  projects[i].time_left  %></span>\n                    <%  if (projects[i].payment_verified == true) {  %>\n                        <div class=\"JobSearchCard-primary-heading-status Tooltip--top\" data-tooltip=\"<%= T_('Mtumiaji huyu amedhibitisha mbinu yake ya Malipo') %>\">\n                            <span class=\"Icon is-success\"><%=  uiIcon('ui-creditcard-check')  %></span> <%= T_('AMEDHIBITISHWA') %>\n                        </div>\n                    <%  }  %>\n                </div>\n\n                <%  if (projects[i].is_private) {  %>\n                <p class=\"JobSearchCard-primary-description\">\n                    <%= T_('Tafadhali <a class=\"JobSearchCard-primary-description-link\" href=\"<[- signup_url ]>\">Jisajili</a> ama <a class=\"JobSearchCard-primary-description-link\" href=\"<[- login_url ]>\">Ingia</a> ili kutazama maelezo.',\n{\n  signup_url: projects[i].signup_redirect_url,\n  login_url: projects[i].login_redirect_url }) %>\n                </p>\n                <%  }  %>\n\n                <%  if (!projects[i].is_private) {  %>\n                    <%  if (projects[i].project_desc) {  %>\n                        <p class=\"JobSearchCard-primary-description\">\n                            <%=  projects[i].project_desc  %>\n                        </p>\n                    <%  }  %>\n                <%  }  %>\n\n                <div class=\"JobSearchCard-primary-tags\" data-qtsb-section=\"page-job-search-new\" data-qtsb-subsection=\"card-job\" data-qtsb-label=\"link-skill\">\n                    <%  for (var j = 0; j < projects[i].skills_info.length; j++) {  %>\n                        <a class=\"JobSearchCard-primary-tagsLink\" href=\"/jobs/<%=  projects[i].skills_info[j].seo_url  %>/\"><%=  projects[i].skills_info[j].name  %></a>\n                    <%  }  %>\n                </div>\n\n                <div class=\"JobSearchCard-primary-hidden\">\n                    <%  if (!projects[i].is_private) {  %>\n                        <div class=\"JobSearchCard-primary-price\">\n                        <%  if (projects[i].bid_avg) {  %>\n                            <%=  projects[i].bid_avg  %>\n                            <span class=\"JobSearchCard-primary-avgBid\">(Avg Bid)</span>\n                        <%  } else {  %>\n                            <%=  T_('<[- project_budget_range ]>', { project_budget_range: projects[i].budget_range })  %>\n                        <%  }  %>\n\n                        </div>\n                    <%  }  %>\n                </div>\n\n                <%  if (projects[i].has_upgrades) {  %>\n                <div class=\"JobSearchCard-primary-promotion\">\n                    <%  if (projects[i].local) {  %>\n                        <span class=\"promotion-tag promotion-local\"><%= T_('Ya Eneo') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].featured) {  %>\n                        <span class=\"promotion-tag promotion-featured\"><%= T_('Iliyoangaziwa') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].urgent) {  %>\n                        <span class=\"promotion-tag promotion-urgent\"><%= T_('Dharura') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].fulltime) {  %>\n                        <span class=\"promotion-tag promotion-fulltime\"><%= T_('Wakati Wote') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].guaranteed) {  %>\n                        <span class=\"promotion-tag promotion-guaranteed\"><%= T_('Imehakikishiwa') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].sealed) {  %>\n                        <span class=\"promotion-tag promotion-sealed\"><%= T_('Imefichwa') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].top) {  %>\n                        <span class=\"promotion-tag promotion-topContest\"><%= T_('Shindano Kuu') %></span>\n                    <%  }  %>\n                    <%  if (projects[i].NDA) {  %>\n                        <span class=\"promotion-tag promotion-nda\"><%=  T_('NDA')  %></span>\n                    <%  }  %>\n                </div>\n                <%  }  %>\n            </div>\n\n            <div class=\"JobSearchCard-secondary\">\n                <%  if (!projects[i].is_private) {  %>\n                    <div class=\"JobSearchCard-secondary-price\">\n                    <%  if (projects[i].bid_avg) {  %>\n                        <%=  projects[i].bid_avg  %>\n                        <%  if (!projects[i].is_contest) {  %>\n                            <span class=\"JobSearchCard-secondary-avgBid\"><%= T_('(Zabuni ya Kadri)') %></span>\n                        <%  }  %>\n                    <%  } else {  %>\n                        <%=  T_('<[- project_budget_range ]>', { project_budget_range: projects[i].budget_range })  %>\n                    <%  }  %>\n\n                    </div>\n                    <%  if (projects[i].is_contest) {  %>\n                        <div class=\"JobSearchCard-secondary-entry\"><%=  projects[i].bid_count  %> <%= T_('wasilisho') %></div>\n                    <%  } else { %>\n                            <div class=\"JobSearchCard-secondary-entry\"><%=  projects[i].bid_count  %> <%= T_('zabuni') %></div>\n                    <%  }  %>\n                <%  }  %>\n\n                <div class=\"JobSearchCard-ctas <%  if (projects[i].is_private) {  %>JobSearchCard-ctas--noTop<%  }  %>\">\n                    <%  if (showPostBtn) {  %>\n                        <%  if (!projects[i].is_private) {  %>\n                            <%  if (projects[i].is_contest) {  %>\n                                <a href=\"/buyers/repost.php?id=<%=  projects[i].project_id  %>\"\n                                    class=\"JobSearchCard-ctas-btn btn btn-mini btn-primary\"\n                                    data-qtsb-section=\"page-job-search-new\"\n                                    data-qtsb-subsection=\"card-cta-button\"\n                                    data-qtsb-label=\"post-project-cta\">\n                                        <%= T_('Tuma Mradi Kama Huu') %>\n                                </a>\n                            <%  } else {  %>\n                                <a href=\"/contest/repost-preview.php?id=<%=  projects[i].project_id  %>\"\n                                    class=\"JobSearchCard-ctas-btn btn btn-mini btn-primary\"\n                                    data-qtsb-section=\"page-job-search-new\"\n                                    data-qtsb-subsection=\"card-cta-button\"\n                                    data-qtsb-label=\"post-contest-cta\">\n                                        <%= T_('Tuma Shindano Kama Hili') %>\n                                </a>\n                            <%  }  %>\n                        <%  }  %>\n                    <%  }  %>\n                    <%  if (showBidBtn) {  %>\n                        <%  if (projects[i].is_contest) {  %>\n                            <a href=\"<%=  projects[i].seo_url  %>\"\n                                class=\"JobSearchCard-ctas-btn btn btn-mini btn-success\"\n                                data-qtsb-section=\"page-job-search-new\"\n                                data-qtsb-subsection=\"card-cta-button\"\n                                data-qtsb-label=\"enter-cta\">\n                                    <%= T_('Ingia sasa') %>\n                            </a>\n                        <%  } else {  %>\n                            <a href=\"<%=  projects[i].seo_url  %>\"\n                                class=\"JobSearchCard-ctas-btn btn btn-mini btn-success\"\n                                data-qtsb-section=\"page-job-search-new\"\n                                data-qtsb-subsection=\"card-cta-button\"\n                                data-qtsb-label=\"bid-cta\">\n                                    <%= T_('Weka zabuni sasa') %>\n                            </a>\n                        <%  }  %>\n                    <%  }  %>\n                </div>\n            </div>\n        </div>\n    </div>\n<%  }  %>\n";

function renderTable(parentId, data, showPostBtn$$1, showBidBtn$$1, onClickCallback) {
  // Takes JSON Data of projects/contests/local jobs and displays it
  var parent = document.getElementById(parentId);
  parent.innerHTML = template(tableTemplate)({
    T_: translate,
    projects: data,
    uiIcon: uiIcon,
    showPostBtn: showPostBtn$$1,
    showBidBtn: showBidBtn$$1
  });

  bindElement(onClickCallback, parent);
}

function bindElement(onClickCallback) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  Array.from(parent.querySelectorAll('div[data-project-card="true"]')).forEach(function (el) {
    el.addEventListener('click', function (event) {
      return onClickCallback(event);
    });
    el.querySelectorAll('a').forEach(function (anchorTags) {
      anchorTags.addEventListener('click', function (event) {
        return event.stopPropagation();
      });
    });
  });
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var objectProto$12 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$12.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$13 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$13.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$14 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$14.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$7.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to search.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to search.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY$1) ? noop : function (values) {
  return new Set(values);
};

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The comparator is invoked with
 * two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  return array && array.length ? baseUniq(array, undefined, comparator) : [];
}

var templateSearchDropdown = "<%  for (var i = 0; i < list.length; i++) {  %>\n  <li class=\"AutofillDropdown-dropdown-item\" data-uitest-target=\"oneclick-dropdown-item\" data-id=\"<%-  list[i].id  %>\" data-index=\"<%-  i  %>\"><%-  list[i].name  %></li>\n<%  }  %>\n";

var KEY_ARROW_DOWN = 40;
var KEY_ARROW_UP = 38;
var KEY_ENTER = 13;

var DEFAULT_AUTOFILL_DEBOUNCE_DELAY = 250;
var suggestionsTimeout = void 0;

var AutofillClickableDropdown = function () {
  function AutofillClickableDropdown(options) {
    _classCallCheck(this, AutofillClickableDropdown);

    // Initialize from input
    this.containerEl = options.containerEl;
    this.inputEl = options.inputEl;
    this.dropdownEl = options.dropdownEl;
    this.autofillList = options.autofillList;
    this.autofillSearchOptions = options.autofillSearchOptions || {};
    this.autofillDropdownOptions = options.autofillDropdownOptions || {};
    this.onListItemSelectCallback = options.onListItemSelectCallback || function () {};
    this.debounceAutofill = options.debounceAutofill || false;
    this.autofillDebounceDelay = options.autofillDebounceDelay || DEFAULT_AUTOFILL_DEBOUNCE_DELAY;
    this.isDropdownShown = false;

    // Ensure that all autofill ids are unique
    this.autofillList = this.autofillList.map(function (autofill, index) {
      autofill.id = index;
      return autofill;
    });

    // Initialize internal things
    this._listItemEls = [];
    this._highlightedListItemIndex = -1;
    this.fuzzySearcher = new Fuse(this.autofillList, this.autofillSearchOptions);
    this._onListItemClicked = this._onListItemClicked.bind(this);
    this._onListItemFocused = this._onListItemFocused.bind(this);
    this._bindEvents();
  }

  _createClass(AutofillClickableDropdown, [{
    key: 'setAutofillList',
    value: function setAutofillList(newAutofillList) {
      // Replace old list
      this.autofillList = newAutofillList;
      // Ensure that all autofill ids are unique
      this.autofillList = this.autofillList.map(function (autofill, index) {
        autofill.id = index;
        return autofill;
      });
      // Set up Fuzzy Searcher again
      this.fuzzySearcher = new Fuse(this.autofillList, this.autofillSearchOptions);
    }
  }, {
    key: 'getAutofillList',
    value: function getAutofillList() {
      return this.autofillList;
    }
  }, {
    key: '_selectItem',
    value: function _selectItem(itemId, event) {
      var clickedEntry = this.autofillList.filter(function (item) {
        return parseInt(item.id, 10) === parseInt(itemId, 10);
      })[0];
      this.inputEl.value = clickedEntry.name;
      this.onListItemSelectCallback(clickedEntry, itemId, event);
    }
  }, {
    key: '_debounceSuggestions',
    value: function _debounceSuggestions(event) {
      var _this = this;

      clearTimeout(suggestionsTimeout);
      suggestionsTimeout = setTimeout(function () {
        return _this.addAutofillSuggestions(event);
      }, this.autofillDebounceDelay);
    }
  }, {
    key: 'addAutofillSuggestions',
    value: function addAutofillSuggestions(event) {
      var _this2 = this;

      // Dont respond to the keyups of navigation keys
      if (event.keyCode === KEY_ARROW_DOWN || event.keyCode === KEY_ARROW_UP || event.keyCode === KEY_ENTER) {
        return;
      }

      var searchQuery = event.target.value;
      var listToRender = this.fuzzySearcher.search(searchQuery);

      // Dedupe if set in options
      if (this.autofillDropdownOptions.uniqueWith) {
        listToRender = uniqWith(listToRender, this.autofillDropdownOptions.uniqueWith);
      }

      // Trim list if set in options
      if (this.autofillDropdownOptions.showTop) {
        listToRender = listToRender.slice(0, this.autofillDropdownOptions.showTop);
      }

      // Option to add priority to the autofill dropdown
      if (this.autofillDropdownOptions.prioritiseByField) {
        (function () {
          var field = _this2.autofillDropdownOptions.prioritiseByField;
          listToRender.sort(function (a, b) {
            var priorityOfA = a[field] || 0;
            var priorityOfB = b[field] || 0;
            if (priorityOfA < priorityOfB) {
              return 1;
            } else if (priorityOfA > priorityOfB) {
              return -1;
            }
            return 0;
          });
        })();
      }

      this.renderList(listToRender);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      var _this3 = this;

      this.inputEl.addEventListener('keydown', function (event) {
        // For keyboard navigations mostly
        // Keyboard navigation only if the dropdown is active
        if (!_this3.isDropdownActive()) {
          return;
        }

        // Handle down key. Cycle to the list item previous to the selected one.
        if (event.keyCode === KEY_ARROW_DOWN) {
          event.preventDefault();
          _this3.highlightListItem(_this3.getHighlightedListItemIndex() + 1);
          return;
        }

        // Handle up key. Cycle to the list item next to the selected one.
        if (event.keyCode === KEY_ARROW_UP) {
          event.preventDefault();
          _this3.highlightListItem(_this3.getHighlightedListItemIndex() - 1);
          return;
        }

        // Handle enter key. Select the currently selected list item.
        if (event.keyCode === KEY_ENTER) {
          // If there is a highlighted list item, select
          if (_this3.hasHighlightedItem()) {
            event.preventDefault();
            var highlightedListItemEl = _this3._listItemEls[_this3.getHighlightedListItemIndex()];
            _this3._selectItem(highlightedListItemEl.getAttribute('data-id'), event);
          }

          // Always hide dropdown on any enter press
          _this3.hideDropdown();
        }
      });

      this.inputEl.addEventListener('keyup', this.debounceAutofill ? function (event) {
        return _this3._debounceSuggestions(event);
      } : function (event) {
        return _this3.addAutofillSuggestions(event);
      });

      document.body.addEventListener('click', function () {
        if (_this3.isDropdownShown) {
          _this3.hideDropdown();
        }
      });
    }

    /**
     * NOTE: also resets the highlighted item to none (-1 index)
     */

  }, {
    key: 'hideDropdown',
    value: function hideDropdown() {
      this.highlightListItem(-1);
      this.dropdownEl.classList.add('is-hidden');
      this.isDropdownShown = false;
    }
  }, {
    key: 'showDropdown',
    value: function showDropdown() {
      this.dropdownEl.classList.remove('is-hidden');
      this.isDropdownShown = true;
    }
  }, {
    key: 'isDropdownActive',
    value: function isDropdownActive() {
      return !this.dropdownEl.classList.contains('is-hidden');
    }
  }, {
    key: 'hasHighlightedItem',
    value: function hasHighlightedItem() {
      return this.getHighlightedListItemIndex() >= 0 && this.getHighlightedListItemIndex() < this._listItemEls.length;
    }
  }, {
    key: 'getHighlightedListItemIndex',
    value: function getHighlightedListItemIndex() {
      return this._highlightedListItemIndex;
    }
  }, {
    key: 'highlightListItem',
    value: function highlightListItem(index) {
      // If the last highlighted list item is not -1 or exists then
      // de-highlight it.
      if (this._highlightedListItemIndex !== -1 && this._listItemEls[this._highlightedListItemIndex]) {
        this._listItemEls[this._highlightedListItemIndex].classList.remove('is-highlighted');
      }

      // Limit the new index to the last list item and the first list item.
      this._highlightedListItemIndex = Math.max(Math.min(index, this._listItemEls.length - 1), -1);

      if (this._highlightedListItemIndex !== -1) {
        this._listItemEls[this._highlightedListItemIndex].classList.add('is-highlighted');
      }
    }
  }, {
    key: '_onListItemFocused',
    value: function _onListItemFocused(event) {
      this.highlightListItem(event.target.getAttribute('data-index'));
    }
  }, {
    key: '_onListItemClicked',
    value: function _onListItemClicked(event) {
      this._selectItem(event.target.getAttribute('data-id'), event);
      this.hideDropdown();
    }
  }, {
    key: 'renderList',
    value: function renderList(dropdownList) {
      var _this4 = this;

      // Undelegate events
      Array.from(this.dropdownEl.children).forEach(function (child) {
        child.removeEventListener('focus', _this4._onListItemFocused);
        child.removeEventListener('click', _this4._onListItemClicked);
      });

      // Hide dropdown and do nothing if matches nothing
      if (!dropdownList.length) {
        this.hideDropdown();
        return;
      }

      this.dropdownEl.innerHTML = template(templateSearchDropdown)({
        list: dropdownList
      });

      // Redelegate events to new children
      Array.from(this.dropdownEl.children).forEach(function (child) {
        child.addEventListener('focus', _this4._onListItemFocused);
        child.addEventListener('click', _this4._onListItemClicked);
      });

      // Save the array of the dropdown list items.
      this._listItemEls = Array.from(this.dropdownEl.children);

      this.showDropdown();
    }
  }]);

  return AutofillClickableDropdown;
}();

AutofillClickableDropdown.fetchAutofillList = function () {
  return fetch('/ajax/project/getProjectTitleAutoFills.php').then(function (res) {
    return res.json();
  });
};

var selectorTemplate = "<h5 class=\"SectionJobFilter-heading\"><%=  title  %></h5>\n<ul id=\"<%=  id  %>-selectList\" class=\"SectionJobFilter-selectList fl-form\">\n</ul>\n\n<form id=\"<%=  id  %>-autofillForm\" action=\"\" autocomplete=\"off\">\n<div id=\"<%=  id  %>-autofill-container\" class=\"SectionJobFilter-selectbox\">\n  <label for=\"<%=  id  %>-autofill-input\" class=\"is-accessibly-hidden\">enter skills</label>\n  <input id=\"<%=  id  %>-autofill-input\" name=\"<%=  id  %>-autofill-input\" name=\"text\" type=\"text\" class=\"default-input SectionJobFilter-selectbox-input\" placeholder=\"<%=  placeholder  %>\">\n  <a id=\"<%=  id  %>-autofill-addbtn\" href=\"#\" class=\"SectionJobFilter-selectbox-link\">\n    <span class=\"Icon Icon--highlight Icon--small\"><%=  uiIcon('ui-plus-alt')  %></span>\n  </a>\n  <ul id=\"<%=  id  %>-autofill-dropdown\" class=\"AutofillDropdown-dropdown is-hidden\" data-uitest-target=\"oneclick-dropdown-container\"></ul>\n</div>\n</form>\n";

var selectorItemTemplate = "<li id=\"<%=  id  %>-<%=  item  %>-container\" data-item=\"<%=  item  %>\" class=\"SectionJobFilter-selectList-item Checkbox\">\n  <input id=\"<%=  id  %>-<%=  item  %>\" data-item=\"<%=  item  %>\" class=\"Checkbox-input\" type=\"checkbox\" name=\"skill-set\">\n  <label class=\"Checkbox-label\" for=\"<%=  id  %>-<%=  item  %>\"><%=  item  %></label>\n</li>\n";

var _templateObject = _taggedTemplateLiteral(['Ama weka ', ''], ['Ama weka ', '']);

var IDENTIFIER = 'job-search-selector';
var MAX_ITEMS_RENDERED = 5;
var ITEM_STATUS = {
  CHECKED: 'checked',
  UNCHECKED: 'unchecked' };

/**
                             * Generates a unique identifier
                             * @return {string}  String for the unique identifier.
                             */
function generateUniqueIdentifier$1(title) {
  if (title !== '') {
    return IDENTIFIER + '-' + title;
  }
  var identifier = IDENTIFIER + '-' + Math.floor(Math.random() * 1024);
  // Does the pagination element with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier$1();
  }

  return identifier;
}

var JobSearchSelector = function () {
  /**
                                         * Job Search Selector
                                         *
                                         * @param {HTMLElement} containerEl                      Container to place
                                         *                                                       the selector
                                         * @param {String}      [options.title]                  Title for selector
                                         * @param {Array}       [options.itemList]               List of objects
                                         * @param {Array}       [options.defaultItemList]        List of strings
                                         * @param {Function}    [options.onSelectChangeCallback] Callback
                                         */
  function JobSearchSelector(containerEl, options) {
    var _this = this;

    _classCallCheck(this, JobSearchSelector);

    // Set-up Variables from options
    this.containerEl = containerEl;
    this.title = options.title || '';
    this.id = generateUniqueIdentifier$1(this.title);
    this.itemList = options.itemList || [];
    this.defaultItemList = options.defaultItemList || [];
    this.onSelectChangeCallback = options.onSelectChangeCallback;
    // Initialise Placeholder
    var inputCategory = this.title.toLowerCase();
    this.placeholder = translate(_templateObject, inputCategory);
    // Initialise Variables
    this.selected = []; // Which input/checkboxes are selected
    this.renderedCount = 0; // Counts how many items are rendered

    // Draw base template
    this.containerEl.innerHTML = template(selectorTemplate)({
      id: this.id,
      title: this.title,
      uiIcon: uiIcon,
      placeholder: this.placeholder });

    // Select elements on the base template
    this.selectListEl = document.getElementById(this.id + '-selectList');
    this.autofillFormEl = document.getElementById(this.id + '-autofillForm');
    this.autofillAddBtn = document.getElementById(this.id + '-autofill-addbtn');

    // Draw Default Checkboxes
    this._renderDefaultItems();

    // Autofill Related Elements
    this.autofillContainerEl = document.getElementById(this.id + '-autofill-container');

    this.autofillInputEl = document.getElementById(this.id + '-autofill-input');
    this.autofillDropdownEl = document.getElementById(this.id + '-autofill-dropdown');

    // Set up so autofill form El
    this.autofillFormEl.addEventListener('submit', function (event) {
      return _this._autofillSubmit(event);
    });

    this.autofillAddBtn.addEventListener('click', function (event) {
      return _this._autofillSubmit(event);
    });

    // Creates an Autofill Dropdown
    this.autofillComponent = new AutofillClickableDropdown({
      containerEl: this.autofillContainerEl,
      inputEl: this.autofillInputEl,
      dropdownEl: this.autofillDropdownEl,
      autofillList: this.itemList,
      autofillSearchOptions: { keys: ['name'], threshold: 0.5 },
      autofillDropdownOptions: {
        showTop: 4,
        uniqueWith: function uniqueWith(a, b) {
          return a.name.trim().toLowerCase() === b.name.trim().toLowerCase();
        } },

      onListItemSelectCallback: function onListItemSelectCallback(item) {
        _this._renderItemToList(item.name, ITEM_STATUS.CHECKED);
        _this._pushToSelectedItems(item.name);
        _this.autofillInputEl.value = '';
      },
      hideOnFocusOut: true });
  }

  /**
     * Get all items which are selected as a list of initial objects from
     * item list
     * @returns {Array} Array of objects
     */

  _createClass(JobSearchSelector, [{
    key: 'getSelectedItems',
    value: function getSelectedItems() {
      var _this2 = this;

      var allItems = [];
      this.selected.forEach(function (selectedItem) {
        var itemObject = _this2.itemList.find(function (elem) {
          return elem.name === selectedItem;
        });
        if (itemObject) {
          allItems.push(itemObject);
        }
      });
      return allItems;
    }
  }, {
    key: 'getItemList',
    value: function getItemList() {
      return this.itemList;
    }

    /**
       * Sets a new list of items
       * @param {Array} items Array of Objects
       * @param {Array} defaultItems Names of the default items selected
       */

  }, {
    key: 'setItemList',
    value: function setItemList(items) {
      var defaultItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // Set Items
      this.itemList = items;
      // Set for Autofill Component
      this.autofillComponent.setAutofillList(items);
      // Set up Default Items
      this.defaultItemList = defaultItems;
      this._renderDefaultItems();
    }
  }, {
    key: 'removeAllSelectedItems',
    value: function removeAllSelectedItems() {
      var _this3 = this;

      var selectedItems = this.getSelectedItems();
      selectedItems.forEach(function (item) {
        _this3._removeSelectedItem(item.name, false);
        _this3._unsetCheckedStatus(item.name);
      });
    }
  }, {
    key: 'selectItemByName',
    value: function selectItemByName(itemName) {
      var item = this.itemList.find(function (el) {
        return el.name === itemName;
      });
      if (item) {
        this._renderItemToList(item.name, ITEM_STATUS.CHECKED);
        this._pushToSelectedItems(item.name, false);
        this.autofillInputEl.value = '';
      }
    }

    /**
       * Push item onto selected items if it doesn't exist already
       * @param {String} item The item being selected
       */

  }, {
    key: '_pushToSelectedItems',
    value: function _pushToSelectedItems(item) {
      var executeCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var itemIndex = this.selected.indexOf(item);
      if (itemIndex === -1) {
        this.selected.push(item);
      }
      if (executeCallback && typeof this.onSelectChangeCallback === 'function') {
        this.onSelectChangeCallback();
      }
    }

    /**
       * Removes item (and all duplicates if exists) from selected
       * @param {String} item The item being removed
       */

  }, {
    key: '_removeSelectedItem',
    value: function _removeSelectedItem(item) {
      var executeCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var itemIndex = this.selected.indexOf(item);
      while (itemIndex !== -1) {
        this.selected.splice(itemIndex, 1);
        itemIndex = this.selected.indexOf(item);
      }
      if (executeCallback && typeof this.onSelectChangeCallback === 'function') {
        this.onSelectChangeCallback();
      }
    }

    /**
       * When an item checkbox is clicked
       */

  }, {
    key: '_onItemClick',
    value: function _onItemClick(event) {
      // Current target is the input element, which has the event listener
      var checkboxInput = event.currentTarget;

      // If checkbox was checked
      if (checkboxInput.checked) {
        // Add it to  selected item
        this._pushToSelectedItems(checkboxInput.getAttribute('data-item'));
      } else {
        this._removeSelectedItem(checkboxInput.getAttribute('data-item'));
      }
    }

    /**
       * Renders an item to list with a given status
       * @param {String} item The item being rendered to the list as a checkbox
       * @param {ITEM_STATUS} status The item status as checked or unchecked
       */

  }, {
    key: '_renderItemToList',
    value: function _renderItemToList(item, itemStatus) {
      var _this4 = this;

      // First, iff item is already rendered, just change status
      if (this._isItemRendered(item)) {
        this._setCheckedStatus(item);
        return;
      }

      // If there is already up to max item rendered, then see if we can remove an
      // element from the list
      if (this._getRenderedCount() >= MAX_ITEMS_RENDERED) {
        var elementsRendered = Array.from(this.selectListEl.querySelectorAll('li'));

        elementsRendered.reverse().forEach(function (elem) {
          var elemName = elem.getAttribute('data-item');
          // Try to remove unchecked elements until element count < the max render
          if (_this4._getCheckedStatus(elemName) === false && _this4._getRenderedCount() >= MAX_ITEMS_RENDERED) {
            elem.remove();
          }
        });
      }
      // Now render the item to the list
      var elementTemplate = template(selectorItemTemplate)({
        id: this.id,
        item: item });

      this.selectListEl.insertAdjacentHTML('afterbegin', elementTemplate);
      // Set checkbox as checked
      if (itemStatus === ITEM_STATUS.CHECKED) {
        this._setCheckedStatus(item);
      }
      // Add Event Listener
      document.getElementById(this.id + '-' + item).addEventListener('click', function (event) {
        return _this4._onItemClick(event);
      });
    }

    /**
       * Gets a count of how many items are rendered
       */

  }, {
    key: '_getRenderedCount',
    value: function _getRenderedCount() {
      return this.selectListEl.querySelectorAll('li').length;
    }

    /**
       * Checks if an item is already rendered
       * @param {String} item Name of the item, checks if it's already rendered
       * @returns {Boolean}
       */

  }, {
    key: '_isItemRendered',
    value: function _isItemRendered(item) {
      var exists = false;
      Array.from(this.selectListEl.querySelectorAll('li')).forEach(function (elem) {
        if (elem.getAttribute('data-item') === item) {
          exists = true;
        }
      });
      return exists;
    }

    /**
       * Draws the default checkboxes
       * Called intially in constructor, and only once.
       * Tries to render up to MAX_ITEMS_RENDERED
       */

  }, {
    key: '_renderDefaultItems',
    value: function _renderDefaultItems() {
      var _this5 = this;

      // Loop through default items and if they exist in the itemList, render
      // them
      // Because render item to list pushes to the list from the top, we should
      // loop through the DefaultItemList in reverse

      this.defaultItemList.reverse().forEach(function (item) {
        var inArray = _this5.itemList.find(function (el) {
          return el.name === item;
        });
        // If item was in itemList array and it also hasn't been rendered
        if (inArray && !_this5._isItemRendered(item)) {
          _this5._renderItemToList(item, ITEM_STATUS.UNCHECKED);
        }
      });

      // If renderedCount didn't reach MAX_ITEMS_RENDERED, try to add more items
      // from itemList
      this.itemList.forEach(function (item) {
        if (_this5._getRenderedCount() < MAX_ITEMS_RENDERED) {
          if (!_this5._isItemRendered(item.name)) {
            _this5._renderItemToList(item.name, ITEM_STATUS.UNCHECKED);
          }
        }
      });
    }

    /*
       * Returns whether the checkbox with data-item: item, is checked or not
       * @param {String} item
       */

  }, {
    key: '_getCheckedStatus',
    value: function _getCheckedStatus(item) {
      return document.getElementById(this.id + '-' + item).checked;
    }

    /**
       * Sets status to checked for an item
       */

  }, {
    key: '_setCheckedStatus',
    value: function _setCheckedStatus(item) {
      document.getElementById(this.id + '-' + item).checked = true;
    }
  }, {
    key: '_unsetCheckedStatus',
    value: function _unsetCheckedStatus(item) {
      document.getElementById(this.id + '-' + item).checked = false;
    }

    /**
       * When autofillDropdown is submitted
       */

  }, {
    key: '_autofillSubmit',
    value: function _autofillSubmit(event) {
      event.preventDefault();
      var input = this.autofillInputEl.value;
      var inArray = this.itemList.find(function (el) {
        return el.name === input;
      });
      if (inArray) {
        this._renderItemToList(input, ITEM_STATUS.CHECKED);
        this._pushToSelectedItems(input);
        this.autofillInputEl.value = '';
        return;
      }
      // If submitted doesn't match, select first highlighted item, and show
      // dropdown
      this.autofillComponent.highlightListItem(0);
      this.autofillComponent.showDropdown();
    }
  }]);

  return JobSearchSelector;
}();

var paginationTemplate = "<ul id=\"<%=  currPaginationId  %>\" class=\"Pagination\">\n  <li data-link=\"1\" class=\"Pagination-item\">\n    <a href=\"<%=  firstPageLink  %>\" class=\"btn Pagination-link\">\n      <span>\n        <%=  uiIcon('flicon-pagination-first')  %>\n      </span>\n    </a>\n  </li>\n  <li data-link=\"<%=  prevPage  %>\" class=\"Pagination-item\">\n    <a\n      href=\"#\"\n      data-pagination-prev-button\n      class=\"btn paginate_button Pagination-link\"\n    >\n      <span>\n        <%=  uiIcon('flicon-pagination-prev')  %>\n      </span>\n    </a>\n  </li>\n\n  <%  for (i = 0; i < pageLinks.length; i++) {  %>\n  <li\n    data-link-id=\"<%=  i  %>\"\n    data-link=\"<%=  pageLinks[i]  %>\"\n    class=\"Pagination-item\"\n  >\n    <a\n      href=\"#\"\n      class=\"btn number Pagination-link\n      <%  if (currPage === pageLinks[i]) {  %>\n        is-active\n      <%  }  %>\"\n      ><%=  pageLinks[i]  %></a\n    >\n  </li>\n\n  <%  }  %>\n\n  <li data-link=\"<%=  nextPage  %>\" class=\"Pagination-item\">\n    <a href=\"#\" data-pagination-next-button class=\"btn Pagination-link\">\n      <span>\n        <%=  uiIcon('flicon-pagination-next')  %>\n      </span>\n    </a>\n  </li>\n  <li data-link=\"<%=  lastPage  %>\" class=\"Pagination-item\">\n    <a href=\"<%=  lastPageLink  %>\" class=\"btn Pagination-link\">\n      <span>\n        <%=  uiIcon('flicon-pagination-last')  %>\n      </span>\n    </a>\n  </li>\n</ul>\n";

var defaultOptions$1 = {
  currPage: 1,
  totalItems: 1,
  itemsPerPage: 20,
  onClickCallback: function onClickCallback() {}
};

var PAGE_TYPE = {
  PREV_PAGE: 'prev_page',
  NEXT_PAGE: 'next_page',
  LAST_PAGE: 'last_page'
};

var TOTAL_NUMBERED_LINKS = 3;

/**
 * Generates a unique identifier
 * @return {string}  String for the unique identifier.
 */
function generateUniqueIdentifier$2() {
  var identifier = 'pagination-' + Math.floor(Math.random() * 1024);
  // Does the pagination element with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier$2();
  }

  return identifier;
}

var Pagination = function () {
  /*
   * Pagination Constructor
   * @param {Array}             elementArray            DOM Element id's to
   *                                                    initialise a pagination
   *                                                    object to.
   * @param {Integer}           [options.currPage]      Current Page Number
   * @param {Integer}           [options.totalItems]    Total Items
   * @param {Integer}           [options.itemsPerPage]  Items displayed per page
   * @param {Pagination~onClick}[options.onClick]       Called on click, returns
   *                                                    the page clicked as a
   *                                                    param to the call back
   *                                                    function.
   */
  function Pagination() {
    var _this = this;

    var containerElementIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var opts = arguments[1];

    _classCallCheck(this, Pagination);

    // Merge user options with defaultOptions
    var options = Object.assign({}, defaultOptions$1, opts);
    this.paginationElements = [];
    this.containerElements = [];
    this.currPage = options.currPage;
    this.itemsPerPage = options.itemsPerPage;
    this.totalItems = options.totalItems;
    this.onClickCallback = options.onClickCallback;

    // Find container element, if exists, add them to local variable
    containerElementIds.forEach(function (id) {
      var currentParentEl = document.getElementById(id);
      if (currentParentEl) {
        _this.containerElements.push(currentParentEl);
      }
    });

    this._redrawPaginationElementsAndBindElements();
  }

  /*
   * Sets the current page number and Updates Pagination
   *  @param {Integer} pageNumber The number of items displayed per page
   */

  _createClass(Pagination, [{
    key: 'setCurrPageAndUpdate',
    value: function setCurrPageAndUpdate(pageNumber) {
      if (Number.isNaN(Number.parseInt(pageNumber, 10))) {
        pageNumber = 1;
      }
      pageNumber = Number.parseInt(pageNumber, 10);
      // Handle Invalid Page
      if (pageNumber < 1) {
        pageNumber = 1;
      } else if (pageNumber > this.getTotalPages()) {
        pageNumber = this.getTotalPages();
      }
      this.currPage = pageNumber;
      this._updatePaginationElements();
    }

    /*
     * Changes the items per page and Updates Pagination
     *  PageNumber defaults to be set back to 1
     *  @param {Integer} itemsPerPage The number of items displayed per page
     *  @param {Integer}  pageNumber   The current page displayed
     */

  }, {
    key: 'setItemsPerPageAndUpdate',
    value: function setItemsPerPageAndUpdate(itemsPerPage) {
      var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      itemsPerPage = Number.parseInt(itemsPerPage, 10);
      if (Number.isNaN(itemsPerPage)) {
        return;
      }
      // Handle Invalid Items Per Page
      if (itemsPerPage < 1) {
        itemsPerPage = defaultOptions$1.itemsPerPage;
      }
      this.itemsPerPage = itemsPerPage;
      this.setCurrPageAndUpdate(pageNumber);
      this._redrawPaginationElementsAndBindElements();
    }

    /*
     * Changes the total amount of items and Updates Pagination
     *  Updates the whole pagination object, reinject template or alter values
     *  PageNumber defaults to be set back to 1
     *  @param {Integer} totalItems The number of items displayed per page
     *  @param {pageNumber} pageNumber The current page displayed
     */

  }, {
    key: 'setTotalItemsAndUpdate',
    value: function setTotalItemsAndUpdate(totalItems) {
      var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      totalItems = Number.parseInt(totalItems, 10);
      if (Number.isNaN(totalItems)) {
        return;
      }
      // Handle Invalid Total Items
      if (totalItems < 0) {
        totalItems = 0;
      }
      this.totalItems = totalItems;
      this._redrawPaginationElementsAndBindElements();
      this.setCurrPageAndUpdate(pageNumber);
    }
  }, {
    key: 'getCurrPage',
    value: function getCurrPage() {
      return this.currPage;
    }
  }, {
    key: 'getItemsPerPage',
    value: function getItemsPerPage() {
      return this.itemsPerPage;
    }
  }, {
    key: 'getTotalItems',
    value: function getTotalItems() {
      return this.totalItems;
    }
  }, {
    key: 'getTotalPages',
    value: function getTotalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    }
  }, {
    key: '_getPageLink',
    value: function _getPageLink(page) {
      var url = new URL(window.location);
      var path = url.pathname.endsWith('/') ? url.pathname.substr(0, url.pathname.length - 1) : url.pathname;
      var pageString = page === 1 ? '' : '/' + page;
      url.pathname = '' + path.replace(/\/[0-9]+/, '') + pageString;
      return url.toString();
    }

    /*
     * Given a current page, sets up the page links in the middle of pagination
     * @param {Integer} page page number
     */

  }, {
    key: '_getPageLinks',
    value: function _getPageLinks(page) {
      var pages = [];
      var offset = Math.floor(TOTAL_NUMBERED_LINKS / 2);
      var initial = page - offset;
      var max = page + Math.ceil(TOTAL_NUMBERED_LINKS / 2) - 1;

      var totalPages = this.getTotalPages();
      // If Initial is less than 1, set to 1 and set max to either the total
      //  amount of numbered links shown on pagination or max pages there is
      if (initial < 1) {
        initial = 1;
        max = TOTAL_NUMBERED_LINKS > totalPages ? totalPages : TOTAL_NUMBERED_LINKS;
      } else if (max > totalPages) {
        // If Max is more than total pages, set max to total pages and the initial
        //  to an amount that is TOTAL_NUMBERED_LINKS less than the max
        max = totalPages;
        var countdownInitial = totalPages - TOTAL_NUMBERED_LINKS + 1;
        initial = countdownInitial > 0 ? countdownInitial : 1;
      }

      for (var i = initial; i <= max; i++) {
        pages.push(i);
      }
      return pages;
    }

    /*
     * Small Helper function to return next page number
     * @param {Integer} page Given a page number, return next page number
     */

  }, {
    key: '_getNextPage',
    value: function _getNextPage(page) {
      return page === this.getTotalPages() ? page : page + 1;
    }

    /*
     * Small Helper function to return prev page number
     * @param {Integer} page Given a page number, return previous page number
     */

  }, {
    key: '_getPrevPageNumber',
    value: function _getPrevPageNumber(page) {
      return page === 1 ? 1 : page - 1;
    }

    /*
     * Pagination on Click
     *  This will update the pagination element depending on the click
     */

  }, {
    key: '_onPaginationClick',
    value: function _onPaginationClick(e) {
      e.preventDefault();
      var linkData = e.currentTarget.getAttribute('data-link');
      if (!linkData) {
        return;
      }

      // Get the Page Clicked
      var pageClicked = linkData;
      if (linkData === PAGE_TYPE.PREV_PAGE) {
        pageClicked = this._getPrevPageNumber(this.currPage);
      }
      if (linkData === PAGE_TYPE.NEXT_PAGE) {
        pageClicked = this._getNextPage(this.currPage);
      }
      if (linkData === PAGE_TYPE.LAST_PAGE) {
        pageClicked = this.getTotalPages();
      }
      pageClicked = Number.parseInt(pageClicked, 10);

      // If the clicked page is the same as current page, don't call back
      if (pageClicked === this.getCurrPage()) {
        return;
      }

      // Update pagination element/s to curr page
      this.setCurrPageAndUpdate(pageClicked);
      // Callback
      if (typeof this.onClickCallback !== 'function') {
        return;
      }
      this.onClickCallback(pageClicked);
    }

    /*
     *  Will be used to update the pagination elements.
     *   Happens onClick, when totalItems, currPage, itemsPerPage are updated
     */

  }, {
    key: '_updatePaginationElements',
    value: function _updatePaginationElements() {
      var _this2 = this;

      // For each data-link-id from 0 to TOTAL_NUMBERED_LINKS, update it to
      // the new numbers returned by ._getPageLinks
      var pageLinks = this._getPageLinks(this.currPage);
      Array.from(this.paginationElements).forEach(function (elem) {
        for (var i = 0; i < TOTAL_NUMBERED_LINKS; i++) {
          var dataLink = elem.querySelector('li[data-link-id=\'' + i + '\']');
          if (dataLink) {
            dataLink.setAttribute('data-link', pageLinks[i]);
            var linkEl = dataLink.querySelector('a');
            linkEl.textContent = pageLinks[i];
            linkEl.setAttribute('href', _this2._getPageLink(pageLinks[i]));
            if (pageLinks[i] === _this2.currPage) {
              linkEl.classList.add('is-active');
            } else {
              linkEl.classList.remove('is-active');
            }
          }
        }
      });

      var previousPage = this._getPrevPageNumber(this.currPage);
      if (previousPage > 0) {
        (function () {
          var prevNewHref = _this2._getPageLink(_this2._getPrevPageNumber(_this2.currPage));

          var prevButtons = document.querySelectorAll('[data-pagination-prev-button]');

          prevButtons.forEach(function (nextButton) {
            nextButton.setAttribute('href', prevNewHref);
          });
        })();
      }

      var nextPage = this._getNextPage(this.currPage);
      if (nextPage <= this.totalItems / this.itemsPerPage) {
        (function () {
          var nextNewHref = _this2._getPageLink(nextPage);
          var nextButtons = document.querySelectorAll('[data-pagination-next-button]');
          nextButtons.forEach(function (nextButton) {
            nextButton.setAttribute('href', nextNewHref);
          });
        })();
      }
    }

    /*
     * Redraw pagination elements
     */

  }, {
    key: '_redrawPaginationElementsAndBindElements',
    value: function _redrawPaginationElementsAndBindElements() {
      var _this3 = this;

      // Get Links again and Empty Pagination Elements
      this.paginationElements = [];
      Array.from(this.containerElements).forEach(function (elem) {
        // Generate an Id
        var currPaginationId = generateUniqueIdentifier$2(elem.id);
        var firstPageLink = _this3._getPageLink(1);
        var lastPageLink = _this3._getPageLink(_this3.getTotalPages());
        elem.innerHTML = template(paginationTemplate)({
          uiIcon: uiIcon,
          currPaginationId: currPaginationId,
          pageLinks: _this3._getPageLinks(_this3.currPage),
          currPage: _this3.currPage,
          firstPageLink: firstPageLink,
          lastPageLink: lastPageLink,
          prevPage: PAGE_TYPE.PREV_PAGE,
          nextPage: PAGE_TYPE.NEXT_PAGE,
          lastPage: PAGE_TYPE.LAST_PAGE
        });
        // Add to the list of pagination elemnts held by this instance
        var currPaginationEl = document.getElementById(currPaginationId);
        if (currPaginationEl) {
          _this3.paginationElements.push(currPaginationEl);
        }
      });

      // Add Event Listener to all Pagination Elements created and their
      // table li elements
      Array.from(this.paginationElements).forEach(function (elem) {
        Array.from(elem.querySelectorAll('li')).forEach(function (li) {
          // If no pages, disable the buttons
          if (_this3.getTotalPages() > 0) {
            li.addEventListener('click', function (event) {
              return _this3._onPaginationClick(event);
            });
            li.removeAttribute('disabled');
          } else {
            li.addEventListener('click', function (event) {
              return event.preventDefault();
            });
            li.setAttribute('disabled', 'disabled');
          }
        });
      });
    }
  }]);

  return Pagination;
}();

var ulTemplate = "<ul id=\"<%=  elementId  %>\" class=\"SectionJobFilter-recentSearchesList\">\n</ul>\n";

var _templateObject$1 = _taggedTemplateLiteral(['', ' wa ', ''], ['', ' wa ', '']);

var SearchHistory = function () {
  /**
                                     * searchHistory constructor
                                     * @param {String}    parentId      The parent ID to attach the search history
                                     * @param {String}    elementId     An ID to apply to the search history
                                     * @param {String}    cookieName    The name of the cookie
                                     * @param {Function}  onClickCallback      The onclick event
                                     */
  function SearchHistory(parentId, elementId, cookieName, onClickCallback) {
    var stackSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;

    _classCallCheck(this, SearchHistory);

    this.parentId = parentId;
    this.elementId = elementId;
    this.cookieFullPath = cookieBase + '_' + cookieName;
    this.cookieExpiry = 30; // 30 days
    this.onClickCallback = onClickCallback;
    this.stackSize = stackSize;
    this._draw();
  }

  /**
     * Replace parent inner HTML with a new search history list
     */

  _createClass(SearchHistory, [{
    key: '_draw',
    value: function _draw() {
      // Create the ul template and add it into parent element
      var recentSearchesTemplate = template(ulTemplate)({
        elementId: this.elementId });

      var parentEl = document.getElementById(this.parentId);
      parentEl.innerHTML = recentSearchesTemplate;

      this.ulEl = document.getElementById(this.elementId);

      var recentSearchesArray = this._getList();
      for (var i = 0; i < recentSearchesArray.length; i++) {
        try {
          var keyword = decodeURIComponent(recentSearchesArray[i].keyword);
          var location = recentSearchesArray[i].location;
          var innerText = void 0;
          if (recentSearchesArray[i].location.vicinity !== '') {
            innerText = translate(_templateObject$1, keyword, location.vicinity);
          } else {
            innerText = keyword;
          }
          this._drawLi(i, innerText, keyword, location);
        } catch (e) {
          // no op
        }
      }
    }
  }, {
    key: '_drawLi',
    value: function _drawLi(index, innerText, keyword, location) {
      var _this = this;

      var liEl = document.createElement('li');
      liEl.id = this.elementId + '-' + index;
      liEl.className = 'SectionJobFilter-recentSearchesList-item';
      liEl.innerText = innerText;
      // might be a performance issue in <IE11
      liEl.dataset.keyword = keyword;
      liEl.dataset.location = JSON.stringify(location);
      liEl.addEventListener('click', function (e) {
        return _this._onElementClick(e);
      });
      // insert to the top of the list
      this.ulEl.insertAdjacentElement('afterbegin', liEl);
      return liEl;
    }

    /**
       * Helper function to find the first occurence of the JSON object in the list
       * @param {array}     arr       The array to find index of
       * @param {Object}    val       The value to be compared
       * @param {Function}  comparer  Compare function
       */

  }, {
    key: '_indexOf',
    value: function _indexOf(arr, val, comparer) {
      for (var i = 0, len = arr.length; i < len; ++i) {
        if (i in arr && comparer(arr[i], val)) {
          return i;
        }
      }
      return -1;
    }

    /**
       * Helper function to compare whether 2 JSON object is equal
       * @param {keyword, location} obj1
       * @param {keyword, location} obj2
       */

  }, {
    key: '_comparer',
    value: function _comparer(obj1, obj2) {
      // pesimistic search
      var equal = false;
      if (obj1.keyword === obj2.keyword) {
        equal = true;
      }
      if (obj1.location && obj2.location && obj1.location.vicinity === obj2.location.vicinity) {
        equal = equal && true;
      } else {
        equal = false;
      }
      // const isLocationEqual = Object.keys(obj1.location).reduce((acc, key) => {
      //   if (acc) {
      //     acc = obj1.location[key] === obj2.location[key];
      //   }
      //   return acc;
      // }, true);

      // Because we are only showing keyword and location.vicinity on the list,
      // the comparison is only made for those two.
      return equal;
    }
  }, {
    key: '_onElementClick',
    value: function _onElementClick(e) {
      var data = {
        keyword: decodeURIComponent(e.target.dataset.keyword),
        location: JSON.parse(e.target.dataset.location) };

      // push the element to the top of the stack
      this.push(data);
      if (this.onClickCallback) {
        this.onClickCallback(data);
      }
    }
    /**
       * Return search history as an array
       */

  }, {
    key: '_getList',
    value: function _getList() {
      var cookie = getArrayCookie(this.cookieFullPath);
      return cookie;
    }

    /**
       * Push to the search history stack. If there is duplicate,
       * just move it to the top of the stack
       * @param {keyword, location} newValue
       */

  }, {
    key: 'push',
    value: function push(newValue) {
      var _this2 = this;

      newValue = {
        keyword: encodeURIComponent(newValue.keyword),
        location: newValue.location };

      var cookie = getArrayCookie(this.cookieFullPath);
      var duplicate = cookie.findIndex(function (value) {
        return _this2._comparer(value, newValue);
      });

      if (duplicate !== -1) {
        cookie.splice(duplicate, 1);
      }
      cookie.push(newValue);
      if (cookie.length > this.stackSize) {
        cookie.splice(0, 1);
      }
      setArrayCookie(this.cookieFullPath, cookie, this.cookieExpiry);
      this._draw();
    }
  }, {
    key: 'pop',
    value: function pop() {
      var cookie = getArrayCookie(this.cookieFullPath);
      cookie.pop();
      setArrayCookie(this.cookieFullPath, cookie, this.cookieExpiry);
      this._draw();
    }
  }]);

  return SearchHistory;
}();

var jobAlertModalHeaderTemplate = "<h3 class=\"ProjectSearch-modal-header\"><%= T_('Pata kazi mpya kwa kutafuta kupitia pepe') %></h3>\n";

var jobAlertModalTemplate = "<div class=\"ProjectSearch-modal-fields\">\n\t<p class=\"ProjectSearch-modal-note\"><%= T_('Huwa hatupeani anwani yako ya barua pepe kwa wafanyakazi huru') %></p>\n\t<form action=\"/signup\" method=\"POST\">\n\t\t<input class=\"large-input ProjectSearch-modal-fieldsItem\" type=\"text\" name=\"email_address\" placeholder=\"<%= T_('anwani pepe') %>\">\n\t\t<input type=\"hidden\" name=\"goto\" value=\"<%-  gotoLink  %>\">\n\t\t<button class=\"btn btn-info btn-large ProjectSearch-modal-fieldsItem\" type=\"submit\">\n\t\t    <%= T_('Wezesha') %>\n\t\t</button>\n\t</form>\n\t<p class=\"ProjectSearch-modal-info\"><%= T_('Unaweza kubatilisha vijulisho vya barua pepe wakati wowote') %></p>\n</div>\n";

var otherRelatedTemplate = "<%  if (projectTags.length > 0) {  %>\n    <h3>Other jobs related to <%-  tags_keyword  %></h3>\n    <%  for (var i = 0; i < projectTags.length; i++) {  %>\n        <a class=\"JobSearchCard-tags-link\" href=\"/job-search/<%=  projectTags[i].enc_url  %>/\">\n            <%-  projectTags[i].tag  %>\n        </a>\n        <%  if (i !== projectTags.length - 1) {  %>, <%  }  %>\n    <%  }  %>\n<%  }  %>\n";

var _templateObject$2 = _taggedTemplateLiteral(['Ujuzi'], ['Ujuzi']),
    _templateObject2 = _taggedTemplateLiteral(['Lugha'], ['Lugha']),
    _templateObject3 = _taggedTemplateLiteral(['Kima cha chini mno ni sharti kiwe nambari'], ['Kima cha chini mno ni sharti kiwe nambari']),
    _templateObject4 = _taggedTemplateLiteral(['Kiasi cha juu mno ni sharti kiwe nambari'], ['Kiasi cha juu mno ni sharti kiwe nambari']),
    _templateObject5 = _taggedTemplateLiteral(['Kiasi cha chini mno kisipungue sufuri'], ['Kiasi cha chini mno kisipungue sufuri']),
    _templateObject6 = _taggedTemplateLiteral(['Kiasi cha juu mno hakiwezi kuwa chini ya sufuri'], ['Kiasi cha juu mno hakiwezi kuwa chini ya sufuri']),
    _templateObject7 = _taggedTemplateLiteral(['Kima cha chini mno ni sharti kiwe kidogo kushinda cha juu'], ['Kima cha chini mno ni sharti kiwe kidogo kushinda cha juu']),
    _templateObject8 = _taggedTemplateLiteral(['Kazi za ', ' Jobs in ', ''], ['Kazi za ', ' Jobs in ', '']),
    _templateObject9 = _taggedTemplateLiteral(['Kazi za ', ''], ['Kazi za ', '']),
    _templateObject10 = _taggedTemplateLiteral(['Kazi za juu katika ', ''], ['Kazi za juu katika ', '']),
    _templateObject11 = _taggedTemplateLiteral(['Kazi za ', ' katika eneo lako'], ['Kazi za ', ' katika eneo lako']),
    _templateObject12 = _taggedTemplateLiteral(['Kazi zaidi kwenye sehemu yako'], ['Kazi zaidi kwenye sehemu yako']),
    _templateObject13 = _taggedTemplateLiteral(['Kazi za Juu'], ['Kazi za Juu']);

var DEFAULT_LOCATION = 'Online Job';
var DEFAULT_HOURLY_DURATION = 'false';
var SCROLL_SPEED = 600;
var JOBS_PAGE = 'JobsPage';
var WORK_PAGE = 'WorkPage';
var JOB_SEARCH_PAGE = 'JobSearchPage';
// Page Title
var jobLocationHeroTitleEl = document.getElementById('job-hero-location-title');

var breadcrumbSearchPageEl = document.getElementById('breadcrumb-search-page');

var breadcrumbSearchTitleEl = document.getElementById('breadcrumb-search-title');

var breadcrumbSearchTitleUrlEl = document.getElementById('breadcrumb-search-title-url');

// Body
var pageBody = document.getElementsByTagName('body')[0];

// Search and Filter
var searchFormEl = document.getElementById('search-form');
var keywordInputEl = document.getElementById('keyword-input');
var locationEl = document.getElementById('location-input');

var fixedProjectCheckEl = document.getElementById('fixed-check');
var fixedProjectMinEl = document.getElementById('fixed-min');
var fixedProjectMaxEl = document.getElementById('fixed-max');
var fixedProjectErrorEl = document.getElementById('fixed-error');

var hourlyProjectCheckEl = document.getElementById('hourly-check');
var hourlyDurationSelectEl = document.getElementById('hourly-duration');
var hourlyProjectMinEl = document.getElementById('hourly-min');
var hourlyProjectMaxEl = document.getElementById('hourly-max');
var hourlyProjectErrorEl = document.getElementById('hourly-error');

var contestCheckEl = document.getElementById('contest-check');
var contestMinEl = document.getElementById('contest-min');
var contestMaxEl = document.getElementById('contest-max');
var contestErrorEl = document.getElementById('contest-error');

var localJobsCheckEl = document.getElementById('local-jobs-check');
var featuredJobsCheckEl = document.getElementById('featured-jobs-check');
var recruiterJobsCheckEl = document.getElementById('recruiter-jobs-check');
var fulltimeJobsCheckEl = document.getElementById('fulltime-jobs-check');

var sortEl = document.getElementById('table-sort-select');
var sortValues = Array.from(sortEl.options).map(function (el) {
  var value = JSON.parse(el.value);
  return {
    rawValue: el.value,
    value: {
      sortColumn: value[0],
      sortOrder: value[1],
      paramName: value[2] } };
});
var keywordResultsEl = document.getElementById('keyword-results');
var resultsPerPageEl = document.getElementById('table-row-count-select');
var totalResultsEl = document.getElementById('total-results');
var totalResultsBotEl = document.getElementById('total-results-bottom');
var firstEntryEl = document.getElementById('first-entry');
var lastEntryEl = document.getElementById('last-entry');
// Ordering
var pagination = new Pagination(['top-pagination', 'bottom-pagination'], {
  currPage: initialPageNumber,
  totalItems: initialTotalEntries,
  itemsPerPage: resultSetSize,
  onClickCallback: onPaginationClick });

// Initialise Empty SkillSelector
var skillsSelectorEl = document.getElementById('skills-selector');
var skillsSelector = new JobSearchSelector(skillsSelectorEl, {
  title: translate(_templateObject$2),
  onSelectChangeCallback: function onSelectChangeCallback() {
    qtsp.push({
      eventName: 'user_action',
      section: 'page-job-search-new',
      subsection: 'filters',
      label: 'filter-skill' });

    onSearchChange();
  } });

// Initialise Empty Languages Selector
var languagesSelectorEl = document.getElementById('languages-selector');
var languagesSelector = new JobSearchSelector(languagesSelectorEl, {
  title: translate(_templateObject2),
  onSelectChangeCallback: function onSelectChangeCallback() {
    qtsp.push({
      eventName: 'user_action',
      section: 'page-job-search-new',
      subsection: 'filters',
      label: 'filter-language' });

    onSearchChange();
  } });

var statusFormEl = document.getElementById('status-form');

var recentSearch = new SearchHistory('recent-searches-section', 'recent-searches', 'JOB_SEARCH', updateQueryBasedOnRecentSearch);

var filterBtnEl = document.getElementById('filter-btn');
var filterCloseBtnEl = document.getElementById('filter-close-btn');
var filterCloseLinkEl = document.getElementById('filter-close-link');
var filterPanelEl = document.getElementById('main');
// const mainContent = document.getElementById('main');
var createAlertLinkEl = document.getElementById('create-alert-link');

// Queries Ajax Endpoint and updates elements on page
function queryTableDataAndRender(jsonObject, pushToHistory) {
  return doPostRequest(jsonObject).then(function (response) {
    // Do any updates necessary
    if (pagination.getTotalItems() !== response.iTotalDisplayRecords) {
      // Update pagination, reset to page 1
      pagination.setTotalItemsAndUpdate(response.iTotalDisplayRecords, pagination.getCurrPage());

      updateRecordsPerPage();
    }
    updatePageDetails(jsonObject.tag, jsonObject.vicinity, jsonObject.local, pagination.getCurrPage(), pushToHistory);

    return response;
  }).then(function (response) {
    pagination._updatePaginationElements();
    // Render the Table
    renderTable('project-list', response.aaData, showPostBtn, showBidBtn, onItemClick);

    var parent = document.getElementById('other_related');
    parent.innerHTML = template(otherRelatedTemplate)({
      tags_keyword: jsonObject.tag,
      projectTags: response.tagData });
  }).catch(function () {});
}

function onItemClick(event) {
  var targetLink = event.currentTarget.querySelector('[data-heading-link="true"]').href;

  if (event.ctrlKey || event.metaKey) {
    window.open(targetLink, '_blank');
  } else {
    window.location = targetLink;
  }
}

/**
   * Helper function to get the project type to parse to backend
   * @return [false, f, h, c, p, hc, fc]
   *          false = all
   *          f = fixed
   *          h = hourly
   *          p = fixed and hourly
   *          hc = hourly and contest
   *          fc = fixed and contest
   */
function getProjectType() {
  if (checkAllProjectTypesSelected()) {
    return false;
  } else if (fixedProjectCheckEl.checked && contestCheckEl.checked) {
    return 'fc';
  } else if (hourlyProjectCheckEl.checked && contestCheckEl.checked) {
    return 'hc';
  } else if (fixedProjectCheckEl.checked && hourlyProjectCheckEl.checked) {
    return 'p';
  } else if (hourlyProjectCheckEl.checked) {
    return 'h';
  } else if (fixedProjectCheckEl.checked) {
    return 'f';
  } else if (contestCheckEl.checked) {
    return 'c';
  }
  return false;
}

function checkAllProjectTypesSelected() {
  if (fixedProjectCheckEl.checked && hourlyProjectCheckEl.checked && contestCheckEl.checked) {
    return true;
  } else if (!fixedProjectCheckEl.checked && !hourlyProjectCheckEl.checked && !contestCheckEl.checked) {
    return true;
  }
  return false;
}

function onSearchChange(e) {
  var pushToHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (e) {
    var elementType = e.target.type;
    qtsp.push({
      eventName: 'user_action',
      section: 'page-job-search-new',
      subsection: 'budget-filter-' + elementType,
      label: 'others' });
  }
  if (!validateSearchFilters()) {
    return;
  }

  // Get Results Per Page
  var resultsPerPageInt = parseInt(resultsPerPageEl.value, 10);

  // Construct Query Data
  var queryData = {};
  // search keyword
  queryData.tag = searchFormEl.search_keyword.value.trim();
  // project specs
  queryData.type = getProjectType();
  var allProjectTypesSelected = checkAllProjectTypesSelected();
  // exchange rate required to convert input (expected to be in local currenct)
  // to USD, which is expected by the backend
  if (allProjectTypesSelected || fixedProjectCheckEl.checked) {
    queryData.budget_min = getValueForQuery(fixedProjectMinEl.value);
    queryData.budget_max = getValueForQuery(fixedProjectMaxEl.value);
  }
  if (allProjectTypesSelected || contestCheckEl.checked) {
    queryData.contest_budget_min = getValueForQuery(contestMinEl.value);
    queryData.contest_budget_max = getValueForQuery(contestMaxEl.value);
  }
  if (allProjectTypesSelected || hourlyProjectCheckEl.checked) {
    queryData.hourlyrate_min = getValueForQuery(hourlyProjectMinEl.value);
    queryData.hourlyrate_max = getValueForQuery(hourlyProjectMaxEl.value);
    queryData.hourlyProjectDuration = hourlyDurationSelectEl.value;
  }
  queryData.skills_chosen = getSkillIdsFromSelectedSkills() || false;
  queryData.languages = getLanguageCodesFromSelectedLanguages() || false;
  queryData.status = statusFormEl.status.value;
  // search location
  queryData.vicinity = searchFormEl.vicinity.value || false;
  queryData.countries = searchFormEl.country.value || false;
  queryData.lat = searchFormEl.lat.value || false;
  queryData.lon = searchFormEl.lon.value || false;
  if (queryData.lat && queryData.lon || localJobsCheckEl.checked) {
    queryData.local = 'true';
    localJobsCheckEl.checked = true;
  }

  if (featuredJobsCheckEl.checked) {
    queryData.featured = 'true';
  }
  if (recruiterJobsCheckEl.checked) {
    queryData.recruiter = 'true';
  }
  if (fulltimeJobsCheckEl.checked) {
    queryData.fulltime = 'true';
  }

  // table properties
  queryData.iDisplayStart = (pagination.getCurrPage() - 1) * resultsPerPageInt;
  queryData.iDisplayLength = resultsPerPageInt;
  queryData.iSortingCols = 1; // default
  var sortingData = JSON.parse(sortEl.value);
  queryData.iSortCol_0 = sortingData[0];
  queryData.sSortDir_0 = sortingData[1];
  queryData.format_version = 3;

  // T63742
  // Temporary disable highlight due to inconsistent truncation of descriptions.
  if (pageName === JOB_SEARCH_PAGE) {
    queryData.disableHighlights = true;
  }

  queryTableDataAndRender(queryData, pushToHistory);
}

function getValueForQuery(value) {
  if (value === '' || Number.isNaN(value)) {
    return false;
  }
  return exchangerate * parseFloat(value);
}

function updateRecordsPerPage() {
  var totalItems = pagination.getTotalItems();
  // Set total results
  totalResultsEl.textContent = totalItems.toLocaleString();
  totalResultsBotEl.textContent = totalItems.toLocaleString();
  // First entry
  if (totalItems === 0) {
    firstEntryEl.textContent = 0;
  } else {
    firstEntryEl.textContent = (pagination.getCurrPage() - 1) * pagination.getItemsPerPage() + 1;
  }
  // Last Entry
  if (totalItems === 0) {
    lastEntryEl.textContent = 0;
  } else {
    var lastEntry = pagination.getCurrPage() * pagination.getItemsPerPage();
    if (pagination.getTotalItems() < lastEntry) {
      lastEntry = pagination.getTotalItems();
    }
    lastEntryEl.textContent = lastEntry;
  }
}

function onPaginationClick(page) {
  qtsp.push({
    eventName: 'user_action',
    section: 'page-job-search-new',
    subsection: 'pagination',
    label: 'click-page' });

  pagination.setCurrPageAndUpdate(page);
  updateRecordsPerPage();
  onSearchChange();
  scrollOnPageUpdate(document.documentElement, 0, SCROLL_SPEED);
}

function scrollOnPageUpdate(element, toLocation, scrollTime) {
  if (scrollTime <= 0) return;
  var difference = toLocation - element.scrollTop;
  var perTick = difference / scrollTime * 10;

  setTimeout(function () {
    element.scrollTop += perTick;
    if (element.scrollTop == toLocation) return;
    scrollOnPageUpdate(element, toLocation, scrollTime - 10);
  }, 10);
}

function onSortingChange() {
  qtsp.push({
    eventName: 'user_action',
    section: 'page-job-search-new',
    subsection: 'sort-criteria',
    label: 'criteria-select' });

  pagination.setCurrPageAndUpdate(1);
  onSearchChange();
}

function onResultPerPageChange() {
  qtsp.push({
    eventName: 'user_action',
    section: 'page-job-search-new',
    subsection: 'results-per-page',
    label: 'results-select' });

  var resultsPerPageInt = parseInt(resultsPerPageEl.value, 10);
  if (!Number.isNaN(resultsPerPageInt)) {
    // Update Pagination (itemsPerPage change), reset curr page to 1
    pagination.setItemsPerPageAndUpdate(resultsPerPageInt, 1);
    updateRecordsPerPage();
    // Query again
    onSearchChange();
    scrollOnPageUpdate(document.documentElement, 0, SCROLL_SPEED);
  }
}

function onProjectTypeChange() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  handleProjectTypeSelections();
  onSearchChange(e);
}

function handleProjectTypeSelections() {
  var allProjectTypesSelected = checkAllProjectTypesSelected();
  var enableFixedProjects = allProjectTypesSelected || fixedProjectCheckEl.checked;
  var enableHourlyProjects = allProjectTypesSelected || hourlyProjectCheckEl.checked;
  var enableContests = allProjectTypesSelected || contestCheckEl.checked;

  onFixedProjectChange(enableFixedProjects);
  onHourlyChange(enableHourlyProjects);
  onContestChange(enableContests);
}

function onFixedProjectChange() {
  var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (enable) {
    fixedProjectMaxEl.removeAttribute('disabled');
    fixedProjectMinEl.removeAttribute('disabled');
  } else {
    fixedProjectMaxEl.setAttribute('disabled', 'disabled');
    fixedProjectMinEl.setAttribute('disabled', 'disabled');
  }
}

function onHourlyChange() {
  var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  // If hourly projects is selected then enable the two selections if exists
  if (enable) {
    hourlyProjectMinEl.removeAttribute('disabled');
    hourlyProjectMaxEl.removeAttribute('disabled');
    hourlyDurationSelectEl.removeAttribute('disabled');
  } else {
    hourlyProjectMinEl.setAttribute('disabled', 'disabled');
    hourlyProjectMaxEl.setAttribute('disabled', 'disabled');
    hourlyDurationSelectEl.setAttribute('disabled', 'disabled');
  }
}

function onContestChange() {
  var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  // If contest is selected then enable the two selections if exists
  if (enable) {
    contestMinEl.removeAttribute('disabled');
    contestMaxEl.removeAttribute('disabled');
  } else {
    contestMinEl.setAttribute('disabled', 'disabled');
    contestMaxEl.setAttribute('disabled', 'disabled');
  }
}

function clearValidationErrorMessages() {
  fixedProjectErrorEl.innerText = '';
  fixedProjectErrorEl.classList.add('is-hidden');
  hourlyProjectErrorEl.innerText = '';
  hourlyProjectErrorEl.classList.add('is-hidden');
  contestErrorEl.innerText = '';
  contestErrorEl.classList.add('is-hidden');
}

// Validate Search filters which need validating
function validateSearchFilters() {
  var allProjectTypesSelected = checkAllProjectTypesSelected();
  var allFiltersValid = true;
  clearValidationErrorMessages();
  // Fixed Price Projects Check
  if (allProjectTypesSelected || fixedProjectCheckEl.checked) {
    var fixedProjectFieldsValidation = handleValidationAndErrorMessage(fixedProjectMinEl, fixedProjectMaxEl, fixedProjectErrorEl);

    allFiltersValid = allFiltersValid && fixedProjectFieldsValidation;
  }
  // Hourly Projects Check
  if (allProjectTypesSelected || hourlyProjectCheckEl.checked) {
    var hourlyProjectFieldsValidation = handleValidationAndErrorMessage(hourlyProjectMinEl, hourlyProjectMaxEl, hourlyProjectErrorEl);

    allFiltersValid = allFiltersValid && hourlyProjectFieldsValidation;
  }
  // Contests Check
  if (allProjectTypesSelected || contestCheckEl.checked) {
    var contestFieldsValidation = handleValidationAndErrorMessage(contestMinEl, contestMaxEl, contestErrorEl);

    allFiltersValid = allFiltersValid && contestFieldsValidation;
  }
  return allFiltersValid;
}

function handleValidationAndErrorMessage(minEl, maxEl, errorEl) {
  var validation = validateNumericField(minEl, maxEl);
  if (!validation.isValid) {
    errorEl.innerText = validation.errorMessage;
    errorEl.classList.remove('is-hidden');
    return false;
  }
  return true;
}

function validateNumericField(filterMinEl, filterMaxEl) {
  var validation = {
    isValid: false,
    errorMessage: null };

  var min = parseFloat(filterMinEl.value);
  var max = parseFloat(filterMaxEl.value);
  if (Number.isNaN(min) && filterMinEl.value !== '') {
    validation.errorMessage = translate(_templateObject3);
    return validation;
  } else if (Number.isNaN(max) && filterMaxEl.value !== '') {
    validation.errorMessage = translate(_templateObject4);
    return validation;
  }
  if (min < 0 && min !== '') {
    validation.errorMessage = translate(_templateObject5);
    return validation;
  } else if (max < 0 && max !== '') {
    validation.errorMessage = translate(_templateObject6);
    return validation;
  } else if (min > max) {
    validation.errorMessage = translate(_templateObject7);
    return validation;
  }
  validation.isValid = true;
  return validation;
}

// Gets selected skills  and reformats them to return a list of ids
function getSkillIdsFromSelectedSkills() {
  var skillsList = skillsSelector.getSelectedItems();
  var count = 0;
  return skillsList.reduce(function (total, item) {
    count += 1;
    if (count < skillsList.length) {
      return total + item.job_id + ',';
    }
    return total + item.job_id;
  }, '');
}

// Gets selected languages and reformats them to returns a list of codes
function getLanguageCodesFromSelectedLanguages() {
  var languagesList = languagesSelector.getSelectedItems();
  var count = 0;
  return languagesList.reduce(function (total, item) {
    count += 1;
    if (count < languagesList.length) {
      return total + item.code + ',';
    }
    return total + item.code;
  }, '');
}

function showFilter() {
  filterPanelEl.classList.add('is-SectionJobFilter-active');
  pageBody.classList.add('SectionJobFilter-disableBgScroll');
}

function hideFilter() {
  filterPanelEl.classList.remove('is-SectionJobFilter-active');
  pageBody.classList.remove('SectionJobFilter-disableBgScroll');
}

/**
   * Callback when the location is chosen from the maps API
   * @param {formatted_address, lat, lon, vicinity, country} geoInfo
   */
function onLocationSelected(geoInfo) {
  qtsp.push({
    eventName: 'user_action',
    section: 'page-job-search-new',
    subsection: 'search-bar',
    label: 'field-location' });

  // update hidden form for location
  searchFormEl.vicinity.value = geoInfo.vicinity;
  searchFormEl.state_code.value = geoInfo.administrative_area_level_1;
  searchFormEl.country.value = geoInfo.country;
  searchFormEl.lat.value = geoInfo.lat;
  searchFormEl.lon.value = geoInfo.lng;
}

/**
   * Small UI logic when the user focusses on the location input field,
   * the DEFAULT_LOCATION that is prefilled is removed
   */
function onLocationFieldFocusIn() {
  if (locationEl.value === DEFAULT_LOCATION) {
    // clear out the value so the autocomplete can suggest something relevant
    locationEl.value = '';
  }
}

/**
   * If the search location is removed, reset the location search to empty
   * Also updates the title
   */
function onLocationFieldFocusOut() {
  if (locationEl.value === '') {
    // set default value if location is emptied
    locationEl.value = DEFAULT_LOCATION;

    searchFormEl.vicinity.value = '';
    searchFormEl.state_code.value = '';
    searchFormEl.country.value = '';
    searchFormEl.lat.value = '';
    searchFormEl.lon.value = '';
  }
}

/**
   * Update title on the hero section based on keyword and location entered
   */
function updatePageDetails(query, location, local, pageNum, pushToHistory) {
  var pageTitle = void 0;
  var skillsName = '';
  if (pageName === JOBS_PAGE) {
    skillsName = skillsSelector.getSelectedItems().map(function (item) {
      return item.name;
    }).join(' ');
  } else if (query.trim()) {
    skillsName = query.trim();
    skillsName = skillsName.charAt(0).toUpperCase() + skillsName.slice(1);
  }
  keywordResultsEl.textContent = '' + skillsName;

  if (skillsName && location) {
    pageTitle = translate(_templateObject8, skillsName, location);
  } else if (skillsName && !location) {
    pageTitle = translate(_templateObject9, skillsName);
  } else if (!skillsName && location) {
    pageTitle = translate(_templateObject10, location);
  } else if (local && skillsName) {
    pageTitle = translate(_templateObject11, skillsName);
  } else if (local) {
    pageTitle = translate(_templateObject12);
  } else {
    pageTitle = translate(_templateObject13);
  }
  jobLocationHeroTitleEl.innerText = pageTitle;
  document.title = pageTitle + ' - ' + siteName;

  var pathUrl = void 0;
  if (pageName === JOBS_PAGE) {
    pathUrl = buildUrlForJobsPage(skillsSelector.getSelectedItems(), pageNum);
  } else if (pageName === JOB_SEARCH_PAGE) {
    var pageLocation = window.location.pathname.split('/')[1];
    pathUrl = '/' + pageLocation + '/';
  } else {
    pathUrl = buildUrl(encodeURIComponent(query), pageNum);
  }

  var newQueryUrl = buildUrlQueryFromFilters(window.location.search, pathUrl);
  updateBreadcrumbs(skillsName || query.trim(), pageNum, pathUrl);
  if (pushToHistory) {
    pushNewHistoryState(newQueryUrl);
  }
}

function buildUrl(query, pageNum) {
  var searchTagString = decodeURIComponent(query).split(' ').join('-');
  var currentUrl = window.location;
  var pageName$$1 = currentUrl.pathname.split('/')[1];
  var newUrl = [pageName$$1, searchTagString];
  if (pageNum > 1) {
    newUrl.push(pageNum);
  }
  newUrl = newUrl.join('/');
  return '/' + newUrl + '/';
}

function buildUrlForJobsPage(skills, pageNum) {
  var skills_url = '';
  if (skills.length) {
    skills_url = skills.reduce(function (total, skill) {
      return total === '' ? skill.seo_url.split('/')[2] : total + '_' + skill.seo_url.split('/')[2];
    }, '');
  }
  var pageName$$1 = window.location.pathname.split('/')[1];

  var newUrl = [];
  if (skills_url) {
    newUrl = [pageName$$1, skills_url];
  } else {
    newUrl = [pageName$$1];
  }

  if (pageNum > 1) {
    newUrl.push(pageNum);
  }
  newUrl = newUrl.join('/');
  return '/' + newUrl + '/';
}

function updateBreadcrumbs(query, pageNum, newUrl) {
  if (pageName === JOBS_PAGE) {
    breadcrumbSearchTitleEl.textContent = query.split(' ')[0];
    if (breadcrumbSearchTitleEl.textContent === '') {
      breadcrumbSearchTitleEl.textContent = translate('Pitia Kazi Zote');
    }
  } else {
    breadcrumbSearchTitleEl.textContent = query;
  }
  breadcrumbSearchPageEl.textContent = pageNum;
  breadcrumbSearchTitleUrlEl.href = newUrl;
}

function pushNewHistoryState(newUrl) {
  window.history.pushState(null, '', newUrl);
}

/**
   * Create a URL string from the search filter and taking into account
   * the rest of the parameters already in the original url
   * @param string currQuery The current query e.g. ?t=x&bla=foo
   * @param string newPathUrl The new url e.g. /job-search/php/
   */
function buildUrlQueryFromFilters(currQuery, newPathUrl) {
  // convert parameters from url to json object
  var data = convertParametersFromUrl(currQuery);

  if (pageName === JOBS_PAGE) {
    if (searchFormEl.search_keyword.value !== '') {
      data.keyword = encodeURIComponent(searchFormEl.search_keyword.value);
    } else {
      delete data.keyword;
    }
  }

  var sortingData = JSON.parse(sortEl.value);
  if (sortingData[2] !== sortValues[0].value.paramName) {
    data.sort = sortingData[2];
  } else {
    delete data.sort;
  }

  if (searchFormEl.vicinity.value !== '') {
    data.vic = searchFormEl.vicinity.value;
  } else {
    delete data.vic;
  }
  if (searchFormEl.country.value !== '') {
    data.country = searchFormEl.country.value;
  } else {
    delete data.country;
  }
  if (searchFormEl.lat.value !== '') {
    data.lat = searchFormEl.lat.value;
  } else {
    delete data.lat;
  }
  if (searchFormEl.lon.value !== '') {
    data.lon = searchFormEl.lon.value;
  } else {
    delete data.lon;
  }

  if (fixedProjectCheckEl.checked === true) {
    data.fixed = true;
  } else {
    delete data.fixed;
  }
  if (fixedProjectMinEl.value !== '') {
    data.fixed_min = fixedProjectMinEl.value * exchangerate;
  } else {
    delete data.fixed_min;
  }
  if (fixedProjectMaxEl.value !== '') {
    data.fixed_max = fixedProjectMaxEl.value * exchangerate;
  } else {
    delete data.fixed_max;
  }

  if (hourlyProjectCheckEl.checked === true) {
    data.hourly = true;
  } else {
    delete data.hourly;
  }
  if (hourlyProjectMinEl.value !== '') {
    data.hourly_min = hourlyProjectMinEl.value * exchangerate;
  } else {
    delete data.hourly_min;
  }
  if (hourlyProjectMaxEl.value !== '') {
    data.hourly_max = hourlyProjectMaxEl.value * exchangerate;
  } else {
    delete data.hourly_max;
  }
  if (hourlyDurationSelectEl.value !== DEFAULT_HOURLY_DURATION) {
    data.hourly_duration = hourlyDurationSelectEl.value;
  } else {
    delete data.hourly_duration;
  }

  if (contestCheckEl.checked === true) {
    data.contest = true;
  } else {
    delete data.contest;
  }
  if (contestMinEl.value !== '') {
    data.contest_min = contestMinEl.value / exchangerate;
  } else {
    delete data.contest_min;
  }
  if (contestMaxEl.value !== '') {
    data.contest_max = contestMaxEl.value / exchangerate;
  } else {
    delete data.contest_max;
  }
  if (localJobsCheckEl.checked === true) {
    data.local = true;
  } else {
    delete data.local;
  }

  if (featuredJobsCheckEl.checked === true) {
    data.featured = true;
  } else {
    delete data.featured;
  }

  if (recruiterJobsCheckEl.checked === true) {
    data.recruiter = true;
  } else {
    delete data.recruiter;
  }

  if (fulltimeJobsCheckEl.checked === true) {
    data.fulltime = true;
  } else {
    delete data.fulltime;
  }

  if (parseInt(resultsPerPageEl.value, 10) !== defaultResultSetSize) {
    data.results = resultsPerPageEl.value;
  } else {
    delete data.results;
  }

  if (pageName !== JOBS_PAGE) {
    var skills_chosen = getSkillIdsFromSelectedSkills();
    if (skills_chosen !== '') {
      data.skills = skills_chosen;
    } else {
      delete data.skills;
    }
  }

  var languages = getLanguageCodesFromSelectedLanguages();
  if (languages !== '') {
    data.languages = languages;
  } else {
    delete data.languages;
  }

  // Jobs Page and Work Page default to Open, so if it is not Open, set status in query string
  // Other Pages (Not Jobs Page or Work Page) should default to All, so if it is not All, set status in query string
  if ((pageName === JOBS_PAGE || pageName === WORK_PAGE) && statusFormEl.status.value !== 'open' || pageName !== JOBS_PAGE && pageName !== WORK_PAGE && statusFormEl.status.value !== 'all') {
    data.status = statusFormEl.status.value;
  } else {
    delete data.status;
  }
  var queryString = jsonToQueryString(data);
  return queryString ? newPathUrl + '?' + queryString : newPathUrl;
}

function jsonToQueryString(json) {
  return Object.keys(json).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  }).join('&');
}

function convertParametersFromUrl(searchString) {
  searchString = searchString.replace('?', '');
  if (searchString == '') {
    return {};
  }
  var params = searchString.split('&').reduce(function (paramObj, param) {
    var parameter = param.split('=');
    if (parameter[0] && parameter[1]) {
      paramObj[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
    }
    return paramObj;
  }, {});
  if (!params) {
    return {};
  }
  return params;
}

function restoreFiltersFromUrlQuery() {
  var url = window.location;
  var query = '';
  var pageNumber = 1;
  if (/^\d+$/.test(url.pathname.split('/')[2])) {
    pageNumber = url.pathname.split('/')[2];
  } else {
    query = url.pathname.split('/')[2];
    pageNumber = url.pathname.split('/')[3];
  }
  var urlSearchString = url.search.substr(1);
  var params = convertParametersFromUrl(urlSearchString);
  if (pageName === JOBS_PAGE) {
    searchFormEl.search_keyword.value = params.keyword ? decodeURIComponent(params.keyword).trim() : '';
  } else {
    searchFormEl.search_keyword.value = query ? decodeURIComponent(query.replace(/-/g, ' ')).trim() : '';
  }
  pagination.setCurrPageAndUpdate(pageNumber);

  var sortOption = sortValues.find(function (elem) {
    return elem.value.paramName === params.sort;
  });

  if (params.sort === sortValues[0].value.paramName || !sortOption) {
    sortEl.value = sortValues[0].rawValue;
  } else {
    sortEl.value = sortOption.rawValue;
  }

  var resultSize = Array.from(resultsPerPageEl.options).find(function (elem) {
    return elem.value === params.results;
  });

  if (params.results && resultSize) {
    resultsPerPageEl.value = resultSize.value;
  } else {
    resultsPerPageEl.value = defaultResultSetSize;
  }

  var isLocationValid = basicLocationValidation(params);
  searchFormEl.vicinity.value = isLocationValid && params.vic ? params.vic : '';
  searchFormEl.country.value = isLocationValid && params.country ? params.country : '';
  searchFormEl.lat.value = isLocationValid && params.lat ? params.lat : '';
  searchFormEl.lon.value = isLocationValid && params.lon ? params.lon : '';
  locationEl.value = isLocationValid && params.vic ? params.vic : DEFAULT_LOCATION;

  localJobsCheckEl.checked = isLocationValid || params.local === 'true';
  featuredJobsCheckEl.checked = params.featured === 'true';
  recruiterJobsCheckEl.checked = params.recruiter === 'true';
  fulltimeJobsCheckEl.checked = params.fulltime === 'true';

  fixedProjectCheckEl.checked = params.fixed === 'true';
  fixedProjectMinEl.value = getValueFromUrl(params.fixed_min);
  fixedProjectMaxEl.value = getValueFromUrl(params.fixed_max);

  hourlyProjectCheckEl.checked = params.hourly === 'true';
  hourlyProjectMinEl.value = getValueFromUrl(params.hourly_min);
  hourlyProjectMaxEl.value = getValueFromUrl(params.hourly_max);
  var hourlyDuration = Array.from(hourlyDurationSelectEl.options).find(function (elem) {
    return elem.value === params.hourly_duration;
  });

  if (params.hourly_duration && hourlyDuration) {
    hourlyDurationSelectEl.value = hourlyDuration.value;
  } else {
    hourlyDurationSelectEl.value = DEFAULT_HOURLY_DURATION;
  }

  contestCheckEl.checked = params.contest === 'true';
  contestMinEl.value = getValueFromUrl(params.contest_min);
  contestMaxEl.value = getValueFromUrl(params.contest_max);

  restoreLanguageFiltersFromUrlQuery();
  restoreSkillFiltersFromUrlQuery();

  if (pageName === JOBS_PAGE || pageName === WORK_PAGE) {
    statusFormEl.status.value = params.status ? params.status : 'open';
  } else if (pageName === JOB_SEARCH_PAGE) {
    statusFormEl.status.value = params.status ? params.status : 'all';
  } else {
    statusFormEl.status.value = params.status ? params.status : 'all';
  }

  handleProjectTypeSelections();
  validateSearchFilters();
}

function getValueFromUrl(value) {
  if (!value || value === '') {
    return '';
  }
  if (Number.isNaN(value)) {
    return value;
  }
  return parseFloat(value) / exchangerate;
}

function restoreLanguageFiltersFromUrlQuery() {
  languagesSelector.removeAllSelectedItems();
  var urlSearchString = window.location.search.substr(1);
  var params = convertParametersFromUrl(urlSearchString);

  var languages = languagesSelector.getItemList();
  var languageParams = params.languages ? params.languages.split(',') : [];
  languageParams.forEach(function (lang) {
    var languageItem = languages.find(function (item) {
      return item.code === lang;
    });
    if (languageItem) {
      languagesSelector.selectItemByName(languageItem.name);
    }
  });
}

function basicLocationValidation(params) {
  if (!params || !params.vic) {
    return false;
  }
  var lat = parseFloat(params.lat);
  var lon = parseFloat(params.lon, 10);
  if (Number.isNaN(lat) || Number.isNaN(lon)) {
    return false;
  }
  if (lat > 90 || lat < -90 || lon > 180 || lon < -180) {
    return false;
  }
  return true;
}

function restoreSkillFiltersFromUrlQuery() {
  skillsSelector.removeAllSelectedItems();
  var skills = skillsSelector.getItemList();
  if (pageName !== JOBS_PAGE) {
    var urlSearchString = window.location.search.substr(1);
    var params = convertParametersFromUrl(urlSearchString);

    var skillParams = params.skills ? params.skills.split(',') : [];
    skillParams.forEach(function (skill) {
      var skillItem = skills.find(function (item) {
        return item.job_id === skill;
      });
      if (skillItem) {
        skillsSelector.selectItemByName(skillItem.name);
      }
    });
  } else {
    var _skillParams = window.location.pathname.split('/')[2];

    if (_skillParams) {
      var _params = _skillParams.split('_');
      _params.forEach(function (skill) {
        var skillItem = skills.find(function (item) {
          return item.seo_url.split('/')[2] === skill.toLowerCase();
        });

        if (skillItem) {
          skillsSelector.selectItemByName(skillItem.name);
        }
      });
    }
  }
}

/**
   * Callback when user click on the recent searches links
   * Then calls onSearchChange
   * @param {keyword, location} param0
   */
function updateQueryBasedOnRecentSearch(_ref) {
  var keyword = _ref.keyword,
      location = _ref.location;

  qtsp.push({
    eventName: 'user_action',
    section: 'page-job-search-new',
    subsection: 'recent-search',
    label: 'click' });

  searchFormEl.search_keyword.value = keyword;
  searchFormEl.vicinity.value = location.vicinity;
  searchFormEl.country.value = location.country;
  searchFormEl.lat.value = location.lat;
  searchFormEl.lon.value = location.lon;
  locationEl.value = location.vicinity || DEFAULT_LOCATION;
  onSearchChange();
}

/**
   * Initialization and binding of the job alert modal
   */
function initAlertModal() {
  // Initialize the popover
  var modalTemplate = {
    header: template(jobAlertModalHeaderTemplate)({
      T_: translate }),

    body: template(jobAlertModalTemplate)({
      T_: translate,
      gotoLink: gotoUrl }) };

  var alertModal = new Modal('job-alert-modal', modalTemplate, {
    size: SIZE.SMALL });

  if (createAlertLinkEl) {
    createAlertLinkEl.addEventListener('click', function (event) {
      event.preventDefault();
      alertModal.show();
    });
  }
}

function initLocationSearch() {
  pushHistory();
  createGeocoding({
    autoCompleteElement: locationEl.id,
    autoCompleteCallback: onLocationSelected,
    autoCompletePreference: AUTOCOMPLETE_PREFERENCE.vicinity });
}

function pushHistory() {
  var popFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (popFirst) {
    recentSearch.pop();
  }
  var query = searchFormEl.search_keyword.value.toLowerCase();
  recentSearch.push({
    keyword: query,
    location: {
      country: searchFormEl.country.value,
      vicinity: searchFormEl.vicinity.value,
      lat: searchFormEl.lat.value,
      lon: searchFormEl.lon.value } });
}

function bindElements() {
  if (locationEl) {
    // hook into the on focus event, to remove or update the field value
    locationEl.addEventListener('focusin', function () {
      return onLocationFieldFocusIn();
    });
    locationEl.addEventListener('focusout', function () {
      return onLocationFieldFocusOut();
    });
    locationEl.addEventListener('keypress', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });
  }
  filterBtnEl.addEventListener('click', function (e) {
    return showFilter(e);
  });
  filterCloseBtnEl.addEventListener('click', function (e) {
    return hideFilter(e);
  });
  filterCloseLinkEl.addEventListener('click', function (e) {
    return hideFilter(e);
  });
  searchFormEl.addEventListener('submit', function (e) {
    e.preventDefault();
    pushHistory();
    onSearchChange(e);
  });

  // Local Jobs Element
  localJobsCheckEl.addEventListener('change', function (e) {
    return onSearchChange(e);
  });
  featuredJobsCheckEl.addEventListener('change', function (e) {
    return onSearchChange(e);
  });
  recruiterJobsCheckEl.addEventListener('change', function (e) {
    return onSearchChange(e);
  });
  fulltimeJobsCheckEl.addEventListener('change', function (e) {
    return onSearchChange(e);
  });

  // for mobile - when the search keyword is focus, show the location
  keywordInputEl.addEventListener('focusin', function () {
    searchFormEl.classList.add('is-onlineSearch--active');
  });

  // set page length selector to default value initially
  resultsPerPageEl.value = defaultResultSetSize;

  // Fixed Price Project Elements
  fixedProjectCheckEl.addEventListener('change', function (e) {
    return onProjectTypeChange(e);
  });
  fixedProjectMinEl.addEventListener('input', debounce(function (e) {
    return onSearchChange(e);
  }, 600));

  fixedProjectMaxEl.addEventListener('input', debounce(function (e) {
    return onSearchChange(e);
  }, 600));

  // Hourly Project Elements
  hourlyProjectCheckEl.addEventListener('change', function (e) {
    return onProjectTypeChange(e);
  });
  hourlyDurationSelectEl.addEventListener('change', function (e) {
    return onSearchChange(e);
  });
  hourlyProjectMinEl.addEventListener('input', debounce(function (e) {
    return onSearchChange(e);
  }, 600));

  hourlyProjectMaxEl.addEventListener('input', debounce(function (e) {
    return onSearchChange(e);
  }, 600));

  // Contest Elements
  contestCheckEl.addEventListener('change', function (e) {
    return onProjectTypeChange(e);
  });
  contestMinEl.addEventListener('input', debounce(function (e) {
    return onSearchChange(e);
  }, 600));
  contestMaxEl.addEventListener('input', debounce(function (e) {
    return onSearchChange(e);
  }, 600));
  sortEl.addEventListener('change', function () {
    return onSortingChange();
  });
  resultsPerPageEl.addEventListener('change', function () {
    return onResultPerPageChange();
  });
  statusFormEl.addEventListener('change', function () {
    return onSearchChange();
  });

  bindElement(onItemClick);
}

function initItemsForSkillsAndLanguages() {
  fetch('/ajax/search/allSkills.php').then(function (data) {
    return data.json();
  }).then(function (data) {
    skillsSelector.setItemList(data.results, ['PHP', 'HTML', 'Javascript', 'CSS', 'Mobile Phone']);

    restoreSkillFiltersFromUrlQuery();
  }).catch();

  fetch('/ajax/search/getActiveLanguages.php').then(function (data) {
    return data.json();
  }).then(function (data) {
    languagesSelector.setItemList(data.results, ['English', 'Spanish', 'German', 'French', 'Portuguese']);

    restoreLanguageFiltersFromUrlQuery();
  }).catch();
}

window.addEventListener('popstate', function () {
  restoreFiltersFromUrlQuery();
  onSearchChange(null, false);
});

function init() {
  bindElements();
  initLocationSearch();
  if (showAlertModal) {
    initAlertModal();
  }
  initItemsForSkillsAndLanguages();
  restoreFiltersFromUrlQuery();
}
init();

(function (h, o, t, j, a, r) {
  h.hj = h.hj || function () {
    (h.hj.q = h.hj.q || []).push(arguments);
  };
  h._hjSettings = { hjid: 1223449, hjsv: 6 };
  a = o.getElementsByTagName('head')[0];
  r = o.createElement('script');
  r.async = 1;
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  a.appendChild(r);
})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
